'use strict'
exports.default = {
  common: {
    zh: '简体中文',
    tw: '繫体中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '백오피스',
    exit: '나가기',
    search: '상품이름/번호',
    tel: '전화',
    address: '주소',
    scenicSpotAreaSelection: '명소지역선택',
    inputRequiredTip: '명소이름을 입력하세요',
    edit: '편집',
    delete: '삭제',
    recommend: '추천설정',
    pay: '결제',
    printOrder: '주문프린트',
    download: '다운로드',
    cancelRecommend: '추천취소',
    cancel: '취소',
    confirm: '확인',
    submit: '변경',
    searchMore: '더보기',
    prompt: '안내',
    basicInfo: '기본정보',
    day: '일',
    hour: '시간',
    minute: '분',
    second: '초'
  },
  title: {
    supplement: '사용 프로세스 보충',
    addDining: '제품(식당)추가',
    balanceSetting: '库存价格',
    productPriceNumber: '재고가격',
    productState: '제품심사',
    productAll: '전체보기',
    productStated: '심사대기',
    productNotState: '심사 미통과',
    orderReport: '주문관리',
    orderDetail: '주문상세정보',
    scenicSpotList: '명소관리',
    addScenicSpot: '명소추가',
    editScenicSpot: '명소편집',
    scenicSpotDetail: '명소정보',
    productManager: '제품관리',
    pdfFilesManage: 'PDF파일창고관리',
    supplyManageProduct: '상품 판매 관리',
    tocDistributorManageProduct: 'TOC 상품 판매 관리',
    pdfBatchList: '차수목록',
    bulkPurchaseList: '대량 구매 목록',
    bulkPurchaseDetail: '대량 구매 정보',
    submitAndPayOrderBatch: '대량으로 구입하다',
    batchPdfFilesList: '차수파일목록',
    addPdfFiles: 'PDF파일창고추가',
    importPdf: 'PDF파일삽입',
    pdfFiles: 'PDF파일',
    DiningDetail: '식당제품정보',
    financeStatement: '재무제표 자동생성',
    statementDetail: '제표상세정보',
    warehouse: '창고관리',
    ticketDepot: '티켓창고관리',
    addTicketDepot: '새로추가된 티켓창고',
    importTicket: '입고',
    pinTicket: '끊은티켓 인증',
    pinTicketMagn: '인증티켓관리',
    trades: '거래명세',
    record: '인출기록',
    counter: '카운터관리',
    addCounter: '카운터추가',
    editCounter: '카운터편집',
    liaison: '연락인관리',
    addLiaison: '연락인추가',
    editLiaison: '연락인편집',
    updatePDFfiles: 'PDF파일창고수정',
    importThirdSystemProduct: '제품 소개 관리',
    productLogList: '제품 수정 기록',
    productLogDetail: '제품 변경 상황',
    productLanguageLogList: '제품 수정 기록',
    productLanguageLogDetail: '제품 다언어 변경 정보'
  },
  lable: {
    selectLogType: '찾기 종류 선택',
    selectLogType_1: '기본 필드',
    selectLogType_2: '다중 언어 필드',
    inputProductId: '제품 ID를 입력',
    inputProductId_placeholder: '제품 ID를 입력',
    customerDataType: '고객 정보 유형',
    customerDataInfo: '고객 정보',
    chooseProductLanguage: '제품 언어를 선택하십시오',
    newOrderEmail: '주문 알림 메 일 박스',
    batchStatus: '차수상태',
    proofPath: '인증서 링크',
    pinTicketNum: '인증 수',
    KlookTicketCanbeUsedDateTBList: ' 6개월 이내',
    KlookTicketCanbeUsedDate: ' 같은 가격의 하루 유효 기간은 6개월이다',
    QuantityMismatch: '판매 표수가 실제 구매 수량과 일치하지 않으면 계속 판매 여부를 확인한다.',
    importProduct: '제품 가져오기',
    system: '도킹 시스템',
    chooseSystem: '도킹 시스템을 선택하십시오',
    klook: '커런트 시스템',
    link: 'LINK',
    thirdNum: '제3자 제품 번호',
    enterThirdNum: '제3자 제품 번호를 입력하십시오.',
    thirdProductTime: '시간대：',
    timeTips: '시간대를 입력해 주세요(1-24)',
    haveInventory: '재고가 있다',
    noInventory: '재고 없음',
    travlerFirstName: '관광객 이름',
    travlerFamilyName: '여행객 성',
    travlerCall: '호칭',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: '선생',
    Ms: '여사',
    Miss: '아가씨',
    Mrs: '부인',
    duration: '지속 시간',
    travellers: '승객 수를 표시하다.',
    voucherUsage: '인증서 사용방법',
    voucherTypeDesc: '인증서 형식',
    voucherValidity: '인증서 유효기간',
    redemptionProcess: '확인 절차',
    transportation: '교통 수단',
    insiderTips: '따스한 풍선 도움말',
    joinAstrict: '참가 제한',
    demand: '요구 사항',
    packageOptions: '패키지 설명',
    itinerary: '진행 설명',
    additionalInformation: '부가 정보',
    meetUpLocation: '집합 설명',
    pickUpLocation: '주소를 수령하다.',
    surcharge: '시간외비용',
    location: '주소',
    submitOrderTip: '이 제품은 특수 제품으로 주문서 제출시 자동으로 지불됩니다. 제출하시겠습니까?',
    submitOrderBatch: '구매 내용을 확인하시기 바랍니다. 예약 보낼 경우에는 구매 총 금액이 자동으로 AGT의 잔액에서 차감됩니다. 주의하시기 바랍니다?',
    location_placeholder: '주소를 입력하십시오',
    duration_placeholder: '활성 시간 입력',
    productConfirmType_placeholder: '확인 종류를 입력하십시오',
    transportation_placeholder: '교통편을 입력하십시오.',
    voucherTypeDesc_placeholder: '인증서 형식을 입력하십시오.',
    voucherUsage_placeholder: '인증서 사용 방법을 입력하십시오.',
    voucherValidity_placeholder: '인증서 유효기간을 입력하십시오.',
    pickUpLocation_placeholder: '수령할 주소를 입력하십시오',
    redemptionProcess_placeholder: '주소를 입력하십시오',
    packageOptions_placeholder: '패키지설명을 입력하십시오',
    itinerary_placeholder: '진행 설명을 입력하십시오',
    additionalInformation_placeholder: '첨부 정보를 입력하십시오',
    surcharge_placeholder: '시간 초과분을 입력하십시오',
    insiderTips_placeholder: '포근한 풍선 도움말을 입력하십시오.',
    updateType: '类型修改',
    shareQrCode: '2차원 코드',
    setQrCode: 'QR코드 설정',
    addCoupon: '쿠폰 신규 추가',
    couponName: '쿠폰 명칭',
    couponAmount: '쿠폰 금액',
    couponOrder: '쿠폰 거래',
    couponCode: '쿠폰 코드',
    addCouponCode: '쿠폰 코드 신규 추가',
    downloadCouponCode: '쿠폰 코드 다운로드',
    batchDelete: '일괄 삭제',
    downloadNow: '{cnt}장을 신규 추가했습니다. 다운로드하시겠습니까?',
    tipMessage1: '이름을 입력하십시오',
    examine: '판매점 심사',
    revenueManagement: '수익관리',
    revenueDetail: '수익관리',
    cashManager: '현금인출관리',
    productState: '状态选择',
    orderNum1: '정렬',
    netError: '无法获取该产品信息,系统已自动下线该产品!',
    updateProduct: '更新',
    addProduct: '제품 추가',
    addQrCode: 'QRコードを追加',
    pleasechoice: '골라 주세요',
    identity: '신분증, 신분증, 신분증',
    studentId: '학생증',
    officerId: '장교증',
    passport: '여권 3.',
    residence: '호구본 (아동 선택하십시오)',
    hongKongandMacaopass: '홍콩 마카오 통행증',
    cellsyndrome: '대포증',
    identificationNumber: '번호',
    children: '(아동 입력 생년월일)',
    addressinformation: '주소 정보',
    expressaddress: '택배 주소',
    postalCode: '우편 번호',
    suborderinformation: '주문서 주문서 ID',
    subordersId: 'JTR주문 확인',
    qxzfbcplx: '등록할 제품유형을 선택하세요',
    selectTreeId: '请选择产品类型',
    ticketType: '상품종류',
    jtrticketType: '类型',
    productPriceTypeSetting: '가격 카테고리 설정',
    batchPriceRuleSetting: '차수가격규정설정',
    specificDatePriceSetting: '특정날짜 가격설정',
    currentProducts: '현재제품：',
    currentProducts_saleDate: '현재제품 등록시간대：',
    unlimited: '무제한',
    setProductInventoryAndPrice: '제품재고·가격 대량설정',
    setProductPriceType: '제품 가격 카테고리 설정',
    serialNumber: 'No.',
    period: '시간대',
    timelimit: '시간범위',
    selectDateRange: '날짜범위선택',
    selectTimeRange: '시간범위선택',
    inventory: '재고',
    purchasePrice: '구매가격',
    jtrDistributionPrice: '分销平台采购价',
    stockNum: '장차 재고',
    distributionPrice: '유통가격',
    marketPrice: '시장가격',
    retailPrice: '구매추천가격',
    operating: '실행',
    delete: '삭제',
    chargeback: '退单',
    addTimePeriod: '시간대추가',
    reset: '초기화',
    save: '저장',
    goBack: '뒤로',
    confirm: '확인',
    confirmOrder: '주문확인',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR주문 확인',
    refuse: '주문거절',
    cancelOrder: '取消订单',
    requestCancel: '신청취소',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: '확인',
    cancel: '취소',
    productName: '상품명',
    scene: '场次',
    dataSource: '데이터 원본',
    selectDistributor: '유통사선택',
    authorizedMerchant: '승인업체',
    businessName: '업체이름',
    priceFloatRange: '업체가격승인',
    distributorNameOrNumber: '업체이름/번호',
    distributorNumber: '유통사번호',
    distributorName: '업체이름',
    changeValidTime: '유효기간 변경',
    // suoCountry: '所属城市',
    suoCountry: '키워드입력',
    suoCountrys: '키워드입력',
    productNameOrId: '제품이름/번호',
    productNameOrIds: '제품이름/번호',
    productNameOrIdRemark: '제품이름/번호/비고',
    productDiff: '상품종류',
    productDiffs: '상품종류',
    confirmMethod: '확인방법',
    managerArea: '관리지역',
    productCode: '상품번호',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '소속도시',
    confirmMethods: '확인방법(결제,취소)',
    confirmMethodss: '확인방법(결제,취소)',
    managerAreas: '관리지역',
    different: '상품종류',
    number: '人数',
    status: '상태',
    ticketType0: 'E티켓',
    ticketType1: '종이티켓',
    ticketType2: '체험',
    ticketType22: '체험',
    ticketType3: '일일투어/장기투어',
    ticketType33: '일일투어/장기투어',
    ticketType4: '와이파이',
    ticketType5: '심카드',
    ticketType6: '음식점',
    ticketType66: '음식점',
    ticketType7: '교통',
    ticketType77: '교통',
    ticketType8: '패키지상품',
    ticketType88: '패키지상품',
    ticketType9: '야간버스',
    ticketType99: '야간버스',
    jtrticketType0: '입장권',
    jtrticketType1: '세트 또는 포장 제품',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: '在线支付（预付）',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: '자동확인',
    confirmType00: '자동확인',
    confirmType1: '수동확인',
    confirmType11: '수동확인',
    confirmType12: '수동확인',
    confirmType2: '',
    productSource0: 'JPH상품',
    productSource1: '접속처 상품',
    status0: '심사 대기',
    status1: '심사 통과',
    status2: '심사 미통과',
    status3: '다운로드',
    status4: '초고',
    checkAll: '취소완료',
    faverite0: '추천상품',
    faverite1: '비추천',
    toldAllLeft: '안내：사용날짜의',
    toldAllMiddle: '일전의',
    toldAllMiddles: '일전의',
    toldAllRight: '전 예약',
    orderEmergentTag: '긴급처리주문',
    orderUncertainTag: '결제확인중',
    orderConfirmedTag: '결제완료',
    orderCancellingTag: '취소대기',
    orderCanceledTag: '취소완료',
    orderCompletedTag: '새로운소식',
    orderExpiredTag: '만료됨',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: '환불완료',
    orderUnpaidTag: '결제대기',
    otherSelection: '기타옵션',
    remark: '비고',
    createRoleRemark: '비고',
    productHighlights: '특점',
    currentState: '현재상태',
    youHave: '아직 있습니다',
    processOrder: '이 주문을 처리하러 왔습니다',
    toPayOrder: '이 주문을 결제하러 왔습니다',
    OrderHistory: '주문내역',
    orderDisExplain: '주문 지침 (리셀러만 표시)',
    orderDisExplains: '중복 표 를 입력하지 마시오',
    CustomersInvisible: '고객열람불가',
    SupplierInvisible: '고객 메모',
    addRemark: '비고추가',
    addMessage: '메시지 추가',
    addExplain: '编辑说明',
    confirmation: '정말 이 주문을 확인하시겠습니까',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: '정말 삭제하시겠습니까',
    refusal: '정말 이 주문을 거절하시겠습니까',
    voucherPath: '인증서 링크',
    messageInfo: '订单预订信息',
    orderID: '주문ID',
    sonOrderID: '주문ID',
    jtrOrderId: '渠道单号',
    orderSource: '주문 소스',
    useDate: '지정날짜',
    sonProduct: '자산품',
    useDate1: '지정날짜',
    useDates: '지정날짜',
    travelDate: '놀이기구',
    createTime: '생성시간',
    endTravelDate: '종료 시간',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: '대화 상대 이름',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: '연락처',
    linkEmail: '연락처 사서함',
    linkAddress: '快递地址',
    linkCode: '邮政编码',
    linkCreditType: '연락처 형식',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: '사용날짜',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: '유통사',
    PDFSendingMode: 'PDF전자티켓 발송방식',
    productPrice: '제품가격',
    Purchase: '구매',
    distributionPriceToc: '분배 가격',
    distributionPriceSum: '분배 가격 총화',
    productSalePrice: '상품의 부동 가격',
    productMinPrice: '최소 가격(디스플레이용)',
    productTcPrice: '제품 오프셋 가격',
    buyNum: '구매수량',
    seatName: '장소 이름',
    jtrAppendNum: '수량 을 늘리다',
    primarynum: '원정 수량',
    cancelNum: '수량을 취소하다',
    orderCnt: '성공 갯수',
    totalAmount: '결제총액',
    customerInfo: '고객정보',
    customerName: '성함',
    cusEmail: '이메일',
    Email: '이메일',
    receiveDate: '수령날짜',
    returnDate: '归还日期',
    FileImport: '파일삽입',
    upload: '업로드',
    onlyUpload: '업로드만 가능',
    noMoreThan: '파일，초과안함',
    generateOrder: '주문생성',
    thisOrder: '이 주문은',
    hasConsumed: '회원이 이미 소비함',
    noData: '데이터없음',
    viewName: '명소이름',
    viewLocal: '소재지',
    viewAddress: '명소주소',
    viewPicture: '명소사진',
    viewRemark: '명소비고',
    viewTelephone: '명소전화',
    payOrder: '주문결제',
    jtrpayOrder: 'jtr주문서 지불',
    jtrAppend: '추가 주문',
    operated: '실행',
    productSource: '상품 소속사',
    searchType: '검색 형식 선택',
    searchType1: '예약번호',
    searchType2: '상품명',
    searchType3: '고객성함',
    searchType4: '',
    searchType5: '고객이메일',
    searchType6: '채널 번호',
    system1: 'EASYGO시스템',
    system2: '2cycle시스템',
    system3: '乐天系统',
    productConfirmType: '확인방법(결제,취소)',
    reserve: '예약',
    isOnlinePay: '지불 방식',
    startDate: '제일 먼저 노는 날.',
    maxNum: '최대 예정 수',
    minNum: '최소 예약 수',
    startNum: '최소 제품 예약 수량',
    isExpress: '택배 배송 지원 여부',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: '배송비',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: '가격 시작 / 종료 시간',
    soldNum: '판매량',
    soldNumSort: '판매수',
    ticketCount: '销量',
    sourceType: '출처',
    sourceType1: 'JPH供应商',
    sourceType2: 'JTR供应商',
    sourceType3: 'KLOOK供应商',
    supplySourceType1: 'JPH产品',
    supplySourceType2: 'JTR产品',
    supplySourceType3: 'KLOOK产品',
    supplySourceType4: '2CYCLE产品',
    supplySourceType5: 'LINK',
    haveNoReserve: '품절',
    upTime: '등록시간',
    productReserve: '상품예약',
    pictureDown: '사진소재 다운로드',
    voideDown: '영상소재 다운로드',
    fileDepot: '文件仓库',
    takeView: '경치',
    productNumber: '제품코드',
    supplier: '협력사',
    operator: '운영상',
    useFate: '사용프로세스',
    supplement: '사용 프로세스 보충',
    supplements: '사용 프로세스 보충',
    ticketTypeName: '표',
    isOnlinepay: '지불 방식',
    num: '건',
    nums: '건',
    num01: '건',
    money: '￥',
    serviceLanguage: '서비스언어',
    productPeople: '소비자요구',
    takeTimeDesc: '영업시간설명',
    productUpTime: '제품상가기간',
    diningTime: '식사시간',
    diningPeople: '식사인원수',
    useTime: '사용시간',
    trafficMethod: '교통방식',
    moneyContant: '비용포함',
    moneyNotContant: '비용미포함',
    priceOrFloat: '가격/재고',
    diningDescription: '제품디테일',
    picture: '포토',
    titles: '타이틀',
    numberBuy: '수량(분)',
    reserveDescription: '예약설명',
    beforeDay: '사전일',
    minteBefore: '분전에예약',
    usingDate: '이팩티브시간',
    canBeUseDate: '유효일기',
    canBeUseDate1: '유효일기',
    returnMethod: '환불설정',
    returnDescription: '환불설명',
    reserveNotice: '예약사항',
    importantNote: '重要提示',
    userNote: '使用说明',
    changeMethod: '티켓교환방식과카운터',
    comnicationPeople: '연락자',
    contionMen: '연락자',
    telphone: '연락방식',
    welcomeData: '접대시간',
    productDescription: '제품묘사',
    dangerConcationMen: '긴급연락자',
    productPackageContainDetail: '세트포함제품디테일',
    productPackageDetail: '세트제품디테일',
    productContainDetail: '제품포함디테일',
    SIMSize: 'SIM카드크기',
    netCover: '네트워크커버',
    threeGNetCover: '3G네트워크데이터',
    fourGNetCover: '4G고속네트워크데이터',
    parts: '부품',
    SIMProductDetail: 'SIM카드제품디테일',
    WIFIProductDetail: 'wifi产品详情',
    tourProductDetail: '일일행/다일행제품디테일',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: '스케쥴시간',
    travelStyle: '노선스타일',
    trafficStyle: '교통도구',
    startCourtyOrEnd: '출발도시/목적지',
    jtrPeopleNum: '产品包含成人数 ',
    jtrChildrenNum: '产品包含儿童数',
    peopleNum: '팀인원수',
    buyMessage: '쇼핑정보',
    tourDetail: '스케쥴디테일',
    giveClass: '증정항목',
    trafficProductDetail: '교통제품디테일',
    ybProductDetail: '야간버스제품 설명',
    // takePomStyle: '1.티켓교환방식',
    takePomStyle: '',
    longWord: '예약성공，플랫폼은 남거둔이메일에 예약성공메일을 보낸다，받은 검증코드 혹은 이차원코드를  아래 환전 카운터에 제시하여 실체표를 수령한다。',
    // canBeTakePom: '2.카운터교환가능',
    canBeTakePom: '',
    counterLink: '수령카운터',
    orderMessages: '새연락',
    saleTimes: '영업시간',
    telphoneCommicta: '연락번호：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: '游客预订日期延后',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: '游客选定日期延后',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '사용일 당일 유효성을 지정 ',
    ordervaildType12: '주문일부터',
    ordervaildType1: '일내유효',
    ordervaildType2: '주문일부터지정일까지',
    ordervaildType3: '유효',
    ordervaildType4: '지정사용일부터',
    ordervaildType5: '지정사용일부터 지정일까지',
    ordervaildType55: '지정사용일부터 지정일까지',
    ordervaildType6: '지정일',
    ordervaildType7: '까지',
    ordervaildType8: '내유효',
    ordervaildType9: '지정한사용일',
    ordervaildType10: '일전부터지정사용일까지',
    ordervaildType11: '일후까지유호',
    ordervaildType13: '天内有效',
    ordervaildType14: '有效',
    ordervaildType15: '内有效',
    orderRefundType0: '환불불가',
    orderRefundType1: '소비전 수시로 환불가능',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: '주문기한이 지나 시스템은 환불 서비스를 제공하지 않음!',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: '전자티켓제품디테일',
    jtrticketDetail: '门票产品详情',
    entityDetail: '실체표제품디테일',
    experienceDetail: '제품디테일체험',
    detail3: '一日游/多日游产品详情',
    detail4: 'WI-FI产品详情',
    detail5: 'SIM卡产品详情',
    detail6: '美食产品详情',
    detail7: '交通产品详情',
    detail8: '优惠套票产品详情',
    eleDetailPreview: '전자티켓제품미리보기',
    entityDetailPreview: '실체표제품미리보기',
    experienceDetailPreview: '제품미리보기체험',
    tourPreview: '일일행/다일행제품미리보기',
    wifiPreview: 'WIFI제품미리보기',
    simPreview: 'SIM카드제품미리보기',
    diningPreview: '식당제품미리보기',
    trafficPreview: '교통제품미리보기',
    packagePreview: '세트제품미리보기',
    spread: '장',
    diningDetail: '식당디테일',
    diningDetailPreview: '식당미리보기',
    orderStatus: '오더상태',
    floatPrice: '浮动价格',
    ifOnLine: '온라인여부',
    onLine: '온라인',
    isEdit: '待上线',
    offLine: '오프라인',
    SalesSituation: '판매상황',
    orderNum: '단',
    copyOperating: '코피',
    graphicEditing: '图文编辑',
    revoke: '심사취소',
    modify: '수정',
    jtrModifylanguage: '多语言编辑',
    more: '더',
    distributionAuthorization: '대리위임',
    specialPrice: '특별가격',
    specialPriceSet: '대리특별가격설정',
    productInformation: '제품정보',
    distributionRange: '대리상가범위위임',
    distributionRangeAll: '전부상가대리가능',
    distributionRangeYes: '지정된상가만대리가능',
    distributionRangeNo: '지정된상가이외의상가대리가능',
    merchantRangeAll: '전부상가',
    merchantRangeYes: '지정상가',
    merchantRangeNo: '지정상가이외',
    specifiedRange: '지정범위',
    account: '계좌',
    PDFSendWay: 'PDF전송방식',
    PDFOnLine: '온라인',
    PDFOffLine: '오프라인',
    connectInformation: '연락정보',
    dialogCancel: '취소',
    dialogSure: '확정',
    dialogSave: '수정보존',
    selectProCategory: '첨가제품의유형을선택',
    ticketsMessage: 'QRコードにより直接入場/利用する施設のチケット。',
    ticketsMessage2: 'QR코드로 종이티켓과 이용하는 명소, 오락시설 입장권을 교환하세요.',
    ticketsMessage3: 'QR코드로 현장 교환하거나 바로 소비하는 오락시설 입장권으로 교환하세요.',
    ticketsMessage4: '일일여행, 1일이상여행, 렌트카투어 상품',
    ticketsMessage5: 'Wi-Fi임대',
    ticketsMessage6: '유심칩',
    ticketsMessage7: '좌석예약, 코스예약 상품',
    ticketsMessage8: '교통권, 픽업샌딩, 렌터카 상품',
    ticketsMessage9: '혜택가격 세트 패키지상품',
    ticketsMessage10: '야간버스 상품',
    serialNumbers: 'No.',
    belongArea: '소재지역',
    connectWay: '연락방식',
    purchasingSituation: '구매상황',
    proStatus: '제품상태',
    ifOnlineStatus: '온라인상태',
    today: '오늘이용예약가능',
    tomorrow: '내일이용예약가능',
    oldPassword: '기존 비밀번호',
    newPassword: '새로운 비밀번호',
    checkPassword: '비밀번호 재확인',
    limitDay: '기타',
    limitDays: '기타',
    auditCannot: '심사불통과이유：',
    notMust: '불제한',
    breakfast: '아침식사',
    lunch: '점심식사',
    afternoonTea: '오후차',
    dinner: '저녘식사',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '야식',
    singleMeal: '일인용식사',
    doubleMeal: '2인용식사',
    thirdMeal: '3~4인용식사',
    fiveMeal: '5~10인용식사',
    tenMeal: '10인시상',
    haveMustData: '구체적시간있음',
    common: '총',
    species: '종',
    dayBefore: '일전',
    applyToRefund: '(현지시간)전환불신청가능',
    updateNotAudited: '심사불통과이유를수정',
    pleaseEnterAudited: '심사불통과이유를입력하세요',
    updateSuccess: '업데이트성공！',
    updateFliture: '업데이트실패！',
    submitError: '유감스럼게 심사제시오류로 제도시 부탁드립니다',
    letterCounter: '반환카운터',
    car: '자동차',
    tram: '전차',
    cruise: '크루즈',
    tourDetailTemp: '스케쥴디테일',
    auditingProductNum: '대기심사제품수랑',
    productNum: '제품수량',
    orderSum: '오더량',
    payBySupplierNum: '거래액',
    balanceNum: '잔액',
    productOrderNum: '플랫폼제품수',
    distritorNum: '대리점수량',
    supplierNum: '협력사수량',
    urgentNum: '긴급처리주문내역',
    confirmNum: '결제완료내역',
    unpassNum: '심사불통과제품',
    beConfirmNum: '결제확인중내역',
    cancelingNum: '취소오더대기처리',
    unPaymentNum: '결제대기내역',
    cancelingOrder: '취소대기내역',
    becancelOrder: '취소완료내역',
    auditingProduct: '심사대기제품',
    supplierAuditing: '협력사심사대기',
    distributorAuditing: '대리점심사대기',
    notice: '알림',
    releaseNotice: '공고발포',
    haveNotNotice: '새로운 소식이 없습니다！',
    unRead: '읽지않았다',
    readed: '읽었다',
    unReadNotice: '읽지않은 알림',
    noticeDetail: '통고디테일',
    messageStart: '본정보부터',
    messageMiddle: '부터효력。 관리원은',
    messageEnd: '본정보발포',
    country: '국가',
    province: '성',
    city: '도시',
    area: '지역',
    year: '년',
    month: '월',
    one: '1',
    two: '2',
    three: '3',
    four: '4',
    five: '5',
    six: '6',
    seven: '7',
    buyPrice: '구매가격',
    selectSupplier: '공급사선택',
    updloadFiles: '파일업로드：',
    pleaseChange: '선택하세요',
    auditMessageEnter: '예약정보입력',
    auditMessageEnter1: '예약정보입력',
    enterAmount: '수량',
    pleaseEnterProductAmount: '제품수량을 선택하세요',
    endSlary: '결제금액(JPY)',
    endTotalAmount: '총 제품 금액',
    ridePlace: '승차위치',
    getOnTheTrain: '승차지점',
    onTrainTime: '승차시간',
    choseUpPlace: '승차지점을 선택해 주세요.',
    choseDownPlace: '하차지점을 선택해 주세요.',
    getDownTheTrain: '하차지점',
    downTrainTime: '하차시간',
    orderMessageByMe: '주문정보',
    confirmEmail: '주문확인메일',
    aboutTipMessage: '접수된 주문를 상세하게 확인해야 하며 반드시 정확해야 합니다.',
    aboutOrderLanguageType: '주문확인 사용언어',
    aboutChangeData: '날짜선택',
    travler: '여행객',
    mainTravler: '대표자',
    travlerName: '여행객이름',
    travlerPhone: '여행객휴대폰',
    customerEmail: '이메일',
    customerWechat: '위챗',
    customerPassport: '여권',
    customerSex: '성별',
    orderByMessage: '주문추가정보',
    orderExplain: '비고',
    productUseData: '사용과정',
    canBeTaken: '환전가능 카운터',
    mustBeComplate: '반드시 전체이름을 적어야 합니다. 인증 시 필요.',
    productCanBeReciveTo: '이 제품은 고객에게 메시지나 이메일을 발송해야 합니다. 전화번호 또는 이메일을 꼭 남겨주세요(비중국대륙 전화번호는 이메일을 적어주세요).',
    submitOrder: '주문제출',
    nowPages: '현재제품',
    travlerEmail: '여행객메일',
    travlerWebchat: '여행객위챗',
    travlerPassport: '여행객여권',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: '여행객성별',
    mustToWrite: '필수입력사항',
    notMustToWrite: '선택입력사항',
    orderStatus0: '주문생성',
    orderStatus1: '주문제출',
    orderStatus2: '주문취소(유통사)',
    orderStatus3: '주문취소(공급사)',
    orderStatus4: '주문확인',
    orderStatus5: '주문완성',
    orderStatus6: '미결제주문취소',
    orderStatus7: '주문거절',
    orderStatus8: '주문취소 확인',
    orderStatus9: '주문취소 거절',
    orderStatus10: '주문 자동확인',
    orderStatus11: '주문 자동완성',
    orderStatus12: '주문 자동취소',
    orderStatus13: '결제 시간초과, 주문 자동취소',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: '订单已出票',
    orderStatus19: '运营商特殊取消',
    orderStatus20: '패스 항공권 특별 취소',
    orderStatus21: '유효 주문서 자동처리',
    orderStatus22: '연결 API 취소',
    orderStatus23: '시스템 한쪽 취소',
    notPaymentTag: '미결제취소',
    travelsSelectData: '주문유효기간 마감일 전',
    jtrOrderRefund0: '游玩日期前',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: '天可以退款',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '天可以退款',
    day: '일',
    ticketPrice: '',
    refundPayment: '환불수수료 :',
    cancelCannot: '취소이유',
    refundCannot: '환불 이유',
    cancelOrRefund: '거절이유',
    cancelReason: '取消理由',
    admin: '관리자',
    clerk: '업무원',
    refuseCannot: '거절이유',
    updateTime: '업데이트시간',
    counterDetails: '카운터',
    applyDate: '신청시간',
    pleaseIntoCancelReason: '거절이유를 입력하세요',
    pleaseIntoCancelCannot: '취소이유를 입력하세요',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: '유통사',
      applyType1: '공급사',
      applyType2: '관리자',
      applyType3: '사무원',
      applyType4: '기타'
    },
    adminAccount: {
      createUser: '캐릭터 만들기',
      roleName: '캐릭터이름',
      createRoleName: '캐릭터이름',
      account: '소속계정',
      applyType: '적용 유형',
      isEnable: '활성화 여부',
      enable: '활성화',
      disable: '비활성화',
      roleDistribution: '권한',
      roleManager: '캐릭터 만들기',
      authMenu: '권한 메뉴',
      checkAll: '모두선택'
    }
  },
  viewMessage: {
    message1: '정말 저장하시겠습니까?',
    message2: '명소이름을 입력하세요',
    message3: '명소주소를 입력하세요',
    message4: '사용추천',
    message5: '정말 저장하시겠습니까?',
    message6: '정말 저장하시겠습니까?',
    message7: '정말 저장하시겠습니까?',
    message8: '명소지역을 선택하세요',
    message9: '3~50자',
    sysError: '시스템 오류!',
    revokeMessage: '이 실행은 심사를 철회합니다. 계속하시겠습니까?',
    revokeSuccess: '심사철회 성공!',
    revokeHavePassed: '이 제품은 이미 심사를 통과했으며 철회할 수 없습니다!',
    revokeHaveNotPassed: '이 제품은 심사를 통과하지 못했으며 철회를 진행할 수 없습니다. 다시 신청해주세요!',
    revokeOperationCanceled: '심사철회가 취소됐습니다!',
    offLineMessage: '이 실행은 제품을 내립니다. 계속하시겠습니까?',
    offLineSuccess: '내리기 성공!',
    offLineOperationCanceled: '내리기 실행취소됨',
    deleteMessage: '이 실행은 본 제품을 영구적으로 삭제합니다. 계속하시겠습니까?',
    deleteMessageOrder: '이 실행은 본 주문을 영구적으로 삭제합니다. 계속하시겠습니까?',
    deleteSuccess: '삭제성공!',
    deleteOperationCanceled: '삭제가 취소됐습니다!',
    thisRangeNotEmpty: '이 지정범위 내 업체를 입력해야 합니다!',
    thisPriceRangeNotEmpty: '업체유통가격승인을 입력해야 합니다!',
    thisPriceRangeNotNum: '숫자를 입력하세요!',
    editSuccess: '편집성공!',
    pleaseDeletePackageProduct: '포장제품을 먼저 삭제하거나 포장제품에서 이 제품을 제거하세요.',
    upToLine: '이 작업을 실행하면 제품이 등록됩니다. 계속하시겠습니까?',
    newToUse1: '이 작업을 실행하면 차수상태가 꺼짐으로 변경됩니다. 계속하시겠습니까?',
    newToUse0: '이 작업을 실행하면 차수상태가 정상으로 변경됩니다. 계속하시겠습니까?',
    fileToDelete: '이 작업을 실행하면 본 파일창고가 영구적으로 삭제됩니다. 계속하시겠습니까?',
    useSuccess: '실행성공',
    useFail: '실행실패',
    holdSuccess: '저장성공!',
    holdError: '저장실패!',
    maxDay: '한번에 최대 10년 데이터 설정가능',
    submitSuccess: '제출성공!',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: '제출실패!',
    balanceNotDone: '계정잔액이 부족합니다. 충전 후 이 주문을 완성해주세요',
    balanceDone: '축하합니다. 결제 성공',
    cancelDone: '취소신청이 발송됐습니다. 업체의 처리를 기다려주세요',
    cancelDone2: '취소 및 환불 처리됐습니다. 페이지를 새로고침하여 확인하세요',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: '업체가 잔액이 부족하므로 현재 주문을 취소할 수 없습니다',
    cancelError1: '系统异常，请联络管理员',
    message10: '편집을 저장하시겠습니까?',
    lable1: '취소',
    lable2: '저장 안함',
    lable3: '저장',
    message11: '3~50자',
    message12: '국가를 선택하세요',
    message13: '지역을 선택하세요',
    message14: '3~50자',
    message15: '기본정보를 모두 기입해주세요',
    message16: '편집을 그만두시겠습니까?',
    message17: '명소를 사용 중이므로 삭제할 수 없습니다!',
    confirmDone: '확인성공',
    tipMessage1: '캐릭터 비고를 입력하세요',
    tipMessage2: '255자를 초과하지 마세요',
    tipMessage3: '캐릭터이름을 입력하세요',
    tipMessage4: '100자를 초과하지 마세요',
    tipMessage5: '커미션 비율을 0에서 100까지밖에 입력할수 없습니다.',
    messageNotCompleteIn: '모든 필수정보를 기입해주세요',
    orderStatusHadUpdate: '오더상태가 업데이트됨',
    orderRefundFalse: '订单退款申请失败',
    message18: '长度在 0 到 500 个字符',
    message19: '长度在 3 到 500 个字符',
    message20: '当前种类在该时间段内已存在',
    cleckOrder: '确认核销订单',
    cleckOrderCanceled: '取消核销',
    cleckSucc: '核销成功'
  },
  counterMessage: {
    counterName: '카운터이름',
    counterAddress: '카운터주소',
    counterTelephone: '카운터전화',
    busineTime: '영업시간',
    counterPic: '카운터사진',
    lable1: '취소',
    lable2: '저장 안함',
    lable3: '저장',
    message1: '카운터이름을 입력하세요',
    message2: '이 실행은 본 카운터를 영구적으로 삭제합니다. 계속하시겠습니까?',
    message3: '삭제성공',
    message4: '사용 중이므로 삭제할 수 없습니다',
    message5: '카운터사진 업로드',
    message6: '편집을 저장하시겠습니까',
    message7: '카운터이름을 입력하세요',
    message8: '카운터주소를 입력하세요',
    message9: '카운터전화를 입력하세요',
    message10: '올바른 카운터전화를 입력하세요',
    message11: '6~20자',
    message12: '카운터 접수시간을 입력하세요',
    message13: '저장실패',
    message14: '저장성공',
    message15: '편집을 그만두시겠습니까？',
    message16: '长度在 1 到 500 个字符'
  },
  liaisonMessage: {
    liaisonName: '이름',
    liaisonTelephone: '연락방식',
    receptionTime: '접수시간',
    message1: '연락인 이름을 입력하세요',
    message2: '연락인 전화를 입력하세요',
    message3: '연락인 접수시간을 입력하세요',
    message4: '정말 이 연락처를 삭제하겠습니까?',
    message5: '삭제성공',
    message6: '사용 중이므로 삭제할 수 없습니다',
    message7: '편집을 저장하겠습니까?',
    message8: '취소',
    message9: '저장 안함',
    message10: '저장',
    message11: '저장실패',
    message12: '편집을 그만두시겠습니까?',
    message13: '저장실패',
    message14: '저장성공'
  },
  registerMessage: {
    directorWechatComment: '당사에서 정보 등을 신속 하 게 알아볼 수 기 때문에 여기를 추천 합니다.자세한 내용은 별도로 제공 되는 설명서를 확인 하시기 바랍니다.',
    supplierRegister: '공급사등록',
    distributorRegister: '유통사등록',
    accountInfo: '계정정보',
    companyInfo: '회사정보',
    mainBusiness: '주요업무내용(업무내용에 맞는 항목을 추천해 드립니다)',
    mainBusiness1: '주영 업무',
    saleType: '판매수단',
    trafficCardTicket: '교통패스권',
    carFree: '송영서비스',
    admissionToThePark: '테마파크',
    foodAndBeverage: '레스토랑예약',
    oneDayTour: '1DAY투어',
    daysTour: '장박투어',
    characteristicExperience: '체험프로그램',
    hotel: '호텔',
    physicalShop: '점포',
    fzShop: '쿠팡',
    mfwShop: '인터파크',
    tbShop: '옥션',
    xcShop: '11번가',
    tcShop: 'G마켓',
    qneShop: 'GS샵 롯데닷컴',
    tnShop: 'CJ몰',
    cupang: '신세계몰',
    gmarket: '롯데홈쇼핑',
    entry: '입력란',
    directorInfo: '업무담당자정보',
    account: '계정',
    password: '비밀번호입력',
    passwordConfirm: '비밀번호 확인',
    address: '소재지',
    companyName: '회사이름',
    logo: '회사로고',
    legalRepresentative: '법정대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyEmail: '회사이메일',
    companyWebsite: '홈페이지/점포링크',
    bankCardNumber: '은행계좌',
    qualification: '자격증명',
    directorName: '이름',
    directorTelephone: '연락전화',
    directorPosition: '직무',
    directorWechat: '위챗',
    directorEmail: '이메일',
    directorCard: '명함',
    phAccount: '로그인 계정을 입력하세요',
    phPassword: '로그인 비밀번호를 입력하세요',
    phPasswordConfirm: '로그인 비밀번호를 확인하세요',
    phCompanyName: '회사 정식등기명을 입력하세요',
    phLogo: '회사로고 업로드',
    phLegalRepresentative: '회사 법정대리인을 입력하세요',
    phCompanyAddress: '회사 상세주소를 입력하세요',
    phCompanyTelephone: '회사전화를 입력하세요',
    phCompanyEmail: '회사 이메일주소를 입력하세요',
    phCompanyWebsite: '회사홈페이지(또는 다른 플랫폼 점포링크)를 입력하세요',
    phBankCardNumber: '회사 은행계좌를 입력하세요',
    phQualification: '회사정식증록 관련자격증명 스캔',
    phDirectorName: '업무담당자 이름을 입력하세요',
    phDirectorTelephone: '업무담당자 전화번호를 입력하세요',
    phDirectorPosition: '업무담당자 직무를 입력하세요',
    phDirectorWechat: '업무담당자 위챗을 입력하세요',
    phDirectorEmail: '업무담당자 이메일을 입력하세요',
    phDirectorCard: '업무담당자 명함 업로드',
    submitResigt: '신청제출',
    message1: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message2: '기입된 계좌정보가 정확한지 확인해주세요!',
    message3: '비밀번호를 입력하세요',
    message4: '올바른 비밀번호를 입력하세요',
    message5: '6~16자',
    message6: '비밀번호를 한번 더 입력하세요',
    message7: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message8: '올바른 비밀번호를 입력하세요',
    message9: '국가를 선택하세요',
    message10: '회사 정식등기명을 입력하세요',
    message11: '6~200자',
    message12: '회사로고를 업로드하세요',
    message13: '회사 법정대리인을 입력하세요',
    message14: '2~200자',
    message15: '회사상세주소를 입력하세요',
    message16: '10~200자',
    message17: '회사전화를 입력하세요',
    message18: '올바른 전화번호를 입력하세요',
    message19: '6~20자',
    message20: '회사 이메일주소를 입력하세요',
    message21: '올바른 이메일주소를 입력하세요',
    message22: '7~50자',
    message23: '회사홈페이지를 입력하세요',
    message24: '4~300자',
    message25: '회사은행계좌를 입력하세요',
    message26: '올바른 은행계좌를 입력하세요',
    message27: '10~100자',
    message28: '회사 정식자격증명을 업로드하세요',
    message29: '업무담당자 이름을 입력하세요',
    message30: '2~50자',
    message31: '연락전화를 입력하세요',
    message32: '올바른 전화번호를 입력하세요',
    message33: '6~20자',
    message34: '직무를 입력하세요',
    message35: '2~50자',
    message36: '위챗을 입력하세요',
    message37: '6~50자',
    message38: '업무담당자 명함을 입력하세요',
    message39: '회원가입을 제출하시겠습니까?',
    message40: '가입성공',
    message41: '가입실패',
    message42: '계정을 입력하세요',
    message43: '6~30자',
    message44: '이미 존재하는 계정',
    message45: '이메일주소를 입력하세요',
    message46: '5~50자',
    message47: '올바른 이메일을 입력하세요',
    message48: '이미 가입된 이메일',
    message49: '회원가입을 그만두시겠습니까?',
    message50: '주영 업무는 적어도 하나를 뽑아 선발할 수 있다',
    message51: '판매 방식은 적어도 하나를 골라 선택하면, 다선할 수 있다.',
    message52: '다른 옵션을 선택할 때, 이 정보는 반드시 기입해야 한다',
    message53: '입력 최대 길이 20'
  },
  menu: {
    sysHome: '시스템 홈페이지',
    product: '제품관리',
    productList: '내 제품',
    releaseProducts: '제품게시',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '상품 판매 관리',
    importThirdSystemProduct: '제품 소개 관리',
    conciseDining: '식당제품게시',
    conciseSetMeal: '신규 포장 제품',
    conciseExperience: '체험제품게시',
    productAuditing: '제품심사',
    addBusFlag: '야간버스상품 신규작성',
    orderManagement: '주문관리',
    orderManagementC: 'C端管理',
    operatorOrderManagement: '주문관리',
    operatorOrderMagnToC: 'ToC주문관리',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: '제품예약',
    distriOrderMagn: '주문관리',
    disTocOrderManagement: 'ToC주문관리',
    bulkPurchaseList: '대량 구매 목록',
    tocDistributorManageProduct: 'ToC 상품 판매 관리',
    distriOrderMagnToC: 'ToC주문관리',
    applyDistribution: 'ToC심사',
    revenueManagement: 'ToC에이전트관리',
    revenueDetail: 'TOC수입관리',
    applyCash: 'TOC현금인출관리',
    operatApplyCash: 'ToC출금 관리',
    coupon: 'ToC쿠폰 관리',
    pinTicketMagn: '인증티켓관리',
    ticket: '종이티켓재고관리',
    ticketDepot: '티켓창고관리',
    warehouse: '창고관리',
    userDepot: '회원창고관리',
    pinTicket: '인증티켓',
    pdfTicket: 'e티켓재고관리',
    pdfFiles: 'PDF파일창고관리',
    shopManage: '업체관리',
    distributor: '유통사관리',
    supplier: '공급사관리',
    scenicSpot: '명소관리',
    scenicSpotList: '명소관리',
    finance: '재무통계',
    financeStatement: '재무제표',
    financeDetail: '재무제표상세정보',
    ActuarialManagement: '보험 계리 관리',
    withdrawals: '충전/인출관리',
    operatorWithdrawal: '충전/인출관리',
    trades: '거래명세',
    record: '충전/인출기록',
    withdrawal: '충전/인출',
    recharge: '충전/인출',
    sys: '시스템관리',
    merchantInfo: '업체정보',
    clerk: '업무원관리',
    adminAccount: '권한관리',
    operator: '관리자관리',
    exportRules: '도출규정관리',
    noticeManager: '공지관리',
    liaisons: '연락인관리',
    counter: '카운터관리',
    pwdSet: '비밀번호설정',
    newOrderEmail: '새 주문서 메일 알림 설정',
    ticketDepot_ticketDepotManager: '티켓창고관리자',
    ticketDepot_stockManager: '재고관리자',
    pdfFiles_stockManager: '재고관리자',
    operatorWithdrawal_operationAuth: '재무실행권한',
    operatorWithdrawal_auditAuth: '재무심사권한',
    auditFlag: '심사가 필요하지 않습니다',
    loginNotice: '쯔워유시스템기능 업데이트공지(20170621)',
    recover: '복구',
    clear: '비우기',
    pageSetting: '홈 페이지 사진 설정',
    productLogList: '제품 수정 기록'
  },
  login: {
    userLogin: '계정로그인',
    rememberLoginStatus: '로그인상태 유지',
    forgetPassword: '비밀번호를 잊으셨습니까?',
    loginIn: '로그인',
    register: '회원가입',
    copyRight: '저작권소유 © 2019 东瀛假日',
    recordInformation: '蜀ICP备18029410号-2',
    recordInformation2: '特定商取引法',
    message1: '계정이름을 입력하세요',
    message2: '비밀번호를 입력하세요',
    message3: '올바른 비밀번호를 입력하세요'
  },
  selectMerchantType: {
    imSupplier: '저는 공급사입니다',
    imDistributor: '저는 유통사입니다',
    selectType: '업체유형을 선택하세요'
  },
  notice: {
    noticeModify: '공지수정',
    noticeAdd: '공지추가',
    noticeTitle: '공지제목：',
    noticeContent: '공지내용',
    noticeTitlePlaceholder: '공지제목을 입력하세요',
    validDate: '유효날짜：',
    DateSelectRange: '날짜범위를 선택하세요',
    publicationScope: '범위선택：',
    all: '보통',
    distributor: '유통사',
    supplier: '공급사',
    pulicationConfirm: '발표하기',
    tip: '안내',
    saveOrNot: '저장하시겠습니까?',
    notSave: '저장 안함',
    save: '저장',
    message1: '3~150자',
    message2: '유효날짜를 선택하세요',
    message3: '범위를 선택하세요',
    message4: '편집을 그만두시겠습니까?',
    message5: '기본정보 미완성',
    message6: '저장성공',
    message7: '저장실패',
    message8: '삭제실패!',
    message9: '삭제성공!',
    message10: '이 실행은 본 파일을 영구적으로 삭제합니다. 계속하시겠습니까?',
    message11: '선택업체를 입력해야 합니다!',
    noticeManage: '공지관리',
    noticePublication: '공지발표',
    noticeTitle1: '공지제목',
    search: '검색',
    index: 'No.',
    title: '제목',
    publicationScope1: '발표범위',
    validDate1: '유효날짜'
  },
  exportRules: {
    exportRuleTitle: '도출규정관리',
    newExportRule: '새도출규정',
    editExportRule: '도출규정편집',
    lableBusinessType: '업체유형',
    pageType: '페이지유형',
    exportRuleName: '도출규정이름',
    exportRuleRemark: '도출규정비고',
    search: '찾기',
    ruleName: '규정이름',
    ruleRemark: '규정비고',
    modify: '수정',
    delete: '삭제',
    lable1: '전부',
    lable2: '유통사',
    lable3: '공급사',
    lable4: '제품일람',
    lable5: '주문일람',
    lable6: '운영사',
    lable7: '알수없음',
    lable8: '도출항목설정',
    lable9: '체거',
    lable10: '추가',
    lable11: '모든항목',
    lable12: '도출항목',
    lable13: '체크 북',
    message1: '정말 삭제하시겠습니까?',
    message2: '삭제성공',
    message3: '기초규정은 삭제할 수 없습니다',
    message4: '규정을 사용 중이므로 삭제할 수 없습니다',
    message5: '도출규정이름을 입력하세요',
    message6: '도출규정비고를 입력하세요',
    message7: '업체유형을 선택하세요',
    message8: '페이지유형을 선택하세요',
    message9: '3~100자',
    message10: '3~500자',
    message11: '정말 재설정하시겠습니까?',
    message12: '저장성공',
    message13: '편집을 그만두시겠습니까?',
    button1: '저장하기',
    button2: '즉시 만들기',
    button3: '재설정'
  },
  clerk: {
    clerkTitle: '업무원관리',
    addClerk: '업무원추가',
    editClerk: '업무원변경',
    account: '계정',
    name: '이름',
    telphone: '전화',
    emailAddress: '이메일주소',
    clerkAccount: '업무원계정',
    clerkName: '업무원이름',
    clerkPwd: '업무원비밀번호',
    confirmPwd: '비밀번호확인',
    clerkTel: '업무원휴대폰번호',
    message1: '업무원계정/이름',
    message2: '권한을 선택하세요',
    message3: '정말 삭제하시겠습니까?',
    message4: '삭제성공',
    message5: '설정성공',
    message6: '업무원계정을 입력하세요',
    message7: '계정은 영문, 숫자, 밑줄, 특수문자로만 구성되며 첫자리는 영문이어야 합니다',
    message8: '업무원이름을 입력하세요',
    message9: '업무원이름을 입력해야 합니다',
    message10: '업무원 비밀번호를 입력하세요',
    message11: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message12: '위에 입력한 것과 일치해야 합니다',
    message13: '업무원 휴대폰번호를 입력하세요',
    message14: '업무원 이메일주소를 입력하세요',
    message15: '이메일로 시스템정보를 받을 수 있습니다',
    message16: '1~50자',
    message17: '올바른 비밀번호를 입력하세요',
    message18: '6~16자',
    message19: '올바른 비밀번호를 입력하세요',
    message20: '저장하시겠습니까?',
    message21: '저장성공',
    message22: '계정을 입력하세요',
    message23: '6~30자',
    message24: '올바른 계정을 입력하세요',
    message25: '이미 존재하는 계정',
    message26: '비밀번호를 한번 더 입력하세요',
    message27: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message28: '5~50자',
    message29: '올바른 이메일을 입력하세요',
    message30: '이미 가입된 이메일',
    message31: '6~20자',
    message32: '올바른 휴대폰번호를 입력하세요',
    message33: '편집을 그만두시겠습니까?',
    lable1: '권한',
    lable2: '제거',
    lable3: '추가',
    lable4: '역할목록',
    lable5: '추가된 역할'
  },
  merchant: {
    merchantInfo: '업체정보',
    distributorManage: '유통사관리',
    supplierManege: '공급사관리',
    all: '전부',
    waitAudit: '심사대기',
    auditPass: '심사통과',
    auditNG: '심사 탈락',
    auditNG2: '심사 미통과',
    auditNGReason: '심사 탈락이유 수정',
    searchContent: '업체이름/ID',
    businessName: '업체이름',
    createDate: '신청시간',
    auditStatus: '상태',
    auditUserName: '심사원',
    lableTodo: '처리',
    lableWatch: '보기',
    lableAuth: '권한',
    lableExpSet: '도출설정',
    accountInfo: '계정정보',
    loginAccount: '로그인계정',
    companyName: '회사이름 ',
    companyLogo: '회사로고',
    legalRepresentative: '법적대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyWebsite: '홈페이지/점포링크',
    companyEmail: '회사이메일',
    bankCardNumber: '은행계좌',
    qualificationPath: '자격증명',
    location: '소재지',
    baseInfo: '기본정보',
    directorInfo: '업무담당자정보',
    directorName: '이름',
    directorPosition: '직무',
    directorEmail: '이메일',
    directorTelephone: '연락처',
    directorWechat: '위챗',
    directorCardPath: '명함',
    setAuthAuditPass: '권한설정 및 심사통과',
    selectAuth: '권한을 선택하세요',
    message1: '권한을 선택하세요',
    message2: '도출설정',
    message3: '도출페이지 유형',
    message4: '제품도출항목 설정',
    message5: '주문도출항목 설정',
    message6: '도출규정',
    message7: '도출규정이름을 입력하세요',
    message8: '도출페이지 유형을 입력하세요',
    message9: '도출규정을 입력하세요',
    message10: '설정성공',
    message11: '(시스템에 있는 업체의 유일한 번호는 회원님의 신분을 식별하는 데 쓰입니다)',
    message12: '유통정황총결',
    message13: '총주문량',
    message14: '총주문금액',
    message15: '총티켓발행량',
    message16: '계정잔액상황',
    message17: '계정잔액',
    message18: '계정 거래일지 보기',
    message19: '충전/인출기록',
    message20: '실행성공',
    message21: '실행실패',
    message22: '심사를 그만두시겠습니까?',
    message23: '한도 설정',
    message24: '항목 내 보 내기',
    lable1: '제거',
    lable2: '추가',
    lable3: '역할목록',
    lable4: '추가된 역할',
    yayaPaySet: '티켓계정설정',
    easyGoUser: '공급사계정',
    yayaPayUser: '티켓계정',
    pleaseEnterYayaPayUser: '티켓계정을 입력하세요',
    pleaseEnterLessTen: '최대 10개 계정을 연동할 수 있습니다!',
    lengthMustLess100: '계정은 100자보다 적거나 같아야 합니다!',
    yayaAccountHadExists: '중복된 티켓계정이 있으므로 추가에 실패했습니다',
    yayaAccountExists: '티켓계정이 중복되었습니다 다시 입력하세요',
    enableSwitch: '스위치 사용하기',
    lineOfCredit: '신임 한도',
    creditDate: '수신 날짜'
  },
  merchantInfo: {
    merchantInfo: '업체정보',
    merchantInfoEdit: '업체정보변경',
    auditNG: '심사 미통과',
    accountInfo: '계정정보',
    auditStatus: '심사상태',
    loginAccount: '로그인계정',
    location: '소재지',
    baseInfo: '기본정보',
    companyName: '회사이름',
    companyLogo: '회사로고',
    legalRepresentative: '법정대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyWebsite: '홈페이지/점포링크',
    companyEmail: '회사이메일',
    bankCardNumber: '은행계좌',
    qualificationPath: '자격증명',
    supplierSummary: '유통정황총결',
    orderTotal: '총주문량',
    orderTotalPay: '총주문금액',
    ticketTotal: '총티켓발행량',
    accountBalanceInfo: '계정잔액상황',
    accountBalance: '계정잔액',
    seeBusinessLog: '계정 거래일지 보기',
    seeRechargeLog0: '충전/인출일지 보기',
    seeRechargeLog1: '인출일지 보기',
    directorInfo: '업무담당자정보',
    directorName: '이름',
    directorPosition: '직무',
    directorEmail: '이메일',
    directorTelephone: '연락전화',
    directorWechat: '위챗',
    directorCardPath: '명함',
    submitAudit: '심사제출',
    submitEdit: '변경제출',
    notSave: '저장 안함',
    save: '저장',
    message1: '(시스템에 있는 업체의 유일한 번호는 회원님의 신분을 식별하는 데 쓰입니다)',
    message2: '기입한 계정정보가 정확한지 확인해보세요!',
    message3: '편집을 저장하시겠습니까?',
    message4: '국가를 선택하세요',
    message5: '회사 정식등록명을 입력하세요',
    message6: '6~200자',
    message7: '회사로고를 업로드하세요',
    message8: '회사 법정대리인을 입력하세요',
    message9: '2~200자',
    message10: '회사상세주소를 입력하세요',
    message11: '10~200자',
    message12: '회사전화를 입력하세요',
    message13: '올바른 전화번호를 입력하세요',
    message14: '6~20자',
    message15: '회사 이메일주소를 입력하세요',
    message16: '올바른 이메일주소를 입력하세요',
    message17: '7~50자',
    message18: '회사 홈페이지를 입력하세요',
    message19: '4~50자',
    message20: '회사은행계좌를 입력하세요',
    message21: '올바른 은행계좌를 입력하세요',
    message22: '10~100자',
    message23: '회사 정식자격증명을 업로드하세요',
    message24: '업무담당자이름을 입력하세요',
    message25: '2~50자',
    message26: '휴대폰 연락처를 입력하세요',
    message27: '올바른 휴대폰번호를 입력하세요',
    message28: '직무를 입력하세요',
    message29: '위챗을 입력하세요',
    message30: '6~50자',
    message31: '업무담당자 명함을 입력하세요',
    message32: '수정하시겠습니까?',
    message33: '수정성공',
    message34: '수정실패',
    message35: '이메일주소를 입력하세요',
    message36: '5~50자',
    message37: '올바른 이메일을 입력하세요',
    message38: '이미 가입된 이메일'
  },
  errorMsg: {
    user: {
      noAuth: '회원 권한이 부족합니다. 관리자에게 연락하세요',
      systemMsg: '시스템오류',
      noUserOrPassword: '계정이 존재하지 않거나 비밀번호가 틀렸습니다',
      setUsernameOrPassword: '계정 혹은 비밀번호를 입력하세요'
    }
  },
  operator: {
    jtrOrderReimburse: '시스템 한쪽 취소',
    operatorManege: '관리자관리',
    addOperator: '관리자추가',
    updateOperator: '관리자변경',
    updatePwd: '비밀변호변경',
    updateInfo: '정보변경',
    auth: '권한',
    searchText: '관리자계정/이름',
    account: '계정',
    name: '이름',
    opearate: '실행',
    opeAccount: '관리자계정',
    opeName: '관리자이름',
    opePwd: '관리자 비밀번호',
    opeNewPwd: '관리자 새비밀번호',
    checkPwd: '비밀번호확인',
    lable1: '제거',
    lable2: '추가',
    lable3: '역할목록',
    lable4: '추가된 역할',
    message1: '권한선택',
    message2: '정말 삭제하시겠습니까?',
    message3: '삭제성공',
    message4: '설정성공',
    message5: '관리자계정을 입력하세요',
    message6: '계정은 영문, 숫자, 밑줄, 특수문자로만 구성되며 첫자리는 영문이어야 합니다',
    message7: '관리자 이름을 입력하세요',
    message8: '관리자 이름을 입력해야 합니다',
    message9: '관리자 비밀번호를 입력하세요',
    message10: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message11: '위에 입력한 것과 일치해야 합니다',
    message12: '1~50자',
    message13: '6~16자',
    message14: '올바른 비밀번호를 입력하세요',
    message15: '저장하시겠습니까? ',
    message16: '저장성공',
    message17: '계정을 입력하세요',
    message18: '6~20자',
    message19: '올바른 계정을 입력하세요',
    message20: '이미 존재하는 계정',
    message21: '비밀번호를 한번 더 입력하세요',
    message22: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message23: '편집을 그만두시겠습니까?'
  },
  product: {
    rule_0_500: '0~500자',
    rule_0_5000: '0~5000자',
    rule_1_200: '1~200자',
    rule_1_2000: '0~2000자',
    rule_1_500: '0~500자',
    rule_0_200: '0~200자',
    rule_0_2000: '0~2000자',
    rule_0_50: '0~50자',
    rule_0_1_500: '0~500자',
    rule_1_50: '1~50자',
    rule_0_20: '0~20자',
    rule_n1_2: '1~2자리 숫자',
    rule_n1_4: '1~4자리 숫자',
    rule_n1_6: '1~6자리 숫자',
    rule_n0_2: '0~2자리 숫자',
    rule_n0_5: '0~5자리 숫자',
    rule_n0_6: '0~6자리 숫자',
    rule_mail: '메일 내용을 입력해 주세요',
    integer_1: '정수를 입력하세요',
    integer_2: '자연수를 입력하세요',
    selDate: '날짜 선택',
    back: '뒤로',
    ticketType_1: 'PDF전자티켓재고',
    ticketType_3: '일부 PDF전자티켓 재고없음',
    ticketType_4: 'PDF전자티켓 없음',
    choose_sys: '시스템을 선택：',
    chooseDepot: '选择仓库',
    baseInfo: '기본정보',
    content: '제품내용',
    priceSet: '가격설정',
    reserveSet: '예약설정',
    saveDraft: '임시저장함에 저장',
    preview: '미리보기',
    submitCheck: '심사제출',
    submitAuditAndPass: '심사를 제출 및 통과했습니다',
    isExitProduct: '제품입력을 그만두시겠습니까?',
    isSaveDraft: '임시저장하시겠습니까?',
    noSave: '저장 안함',
    save: '저장',
    add: '추가',
    edit: '편집',
    product_0: '제품(e티켓)',
    product_1: '제품(종이티켓)',
    product_2: '제품(체험)',
    product_3: '제품(일일여행/1일이상여행)',
    product_4: '제품(WIFI)',
    product_5: '제품(유심)',
    product_6: '제품(식당)',
    product_7: '제품(교통)',
    product_8: '제품(패키지)',
    doNotSave: '내용이 업데이트되지 않았으므로 중복 저장할 필요가 없습니다.',
    reqMsg_1: '축하합니다. 심사를 제출했습니다',
    reqMsg_2: '축하합니다. 저장에 성공하였습니다',
    reqMsg_3: '죄송합니다. 심사제출에 실패하였습니다!',
    reqMsg_4: '죄송합니다. 저장에 실패하였습니다!',
    reqMsg_5: '죄송합니다. 심사제출 오류. 다시 시도해주세요',
    reqMsg_6: '죄송합니다. 저장 오류. 다시 시도해주세요',
    reqMsg_7: '이 패키지에 자제품이 추가되지 않았습니다!',
    reqMsg_8: '축하합니다. 심사를 통과했습니다',
    reqMsg_9: '죄송합니다. 심사를 통과하지 못했습니다!',
    reqMsg_10: '죄송합니다. 심사 오류. 다시 시도해주세요!',
    reqMsg_11: '안타깝게도 제품을 가져오는 동안 오류가 발생했습니다. 다시 시도해 주세요！',
    reqMsg_12: '이 제품 번호는 바인딩되었습니다. 다시 입력하세요！',
    reqMsg_13: '이 제품은 현재 재고가 없으며 수입할 수 없습니다！',
    fileDepot_no: '파일 리포지토리를 선택하세요',
    baseInfo_no: '기본정보 일부 미기입',
    content_no: '제품내용 일부 미기입',
    reserveSet_no: '예약설정 일부 미기입',
    explain01: '이름구성: 지명+제품명++수량+특색, 예시: 북경순경온천(피쉬스파 포함) 2장+남산스키장(E티켓) 2장',
    explain02: '제품제목 하단의 키워드등',
    explain03: '공급사가 편리하게 제품을 검색하도록 유통사는 볼 수 없습니다.',
    explain04: '성인(만18세 이상), 학생(만12~17세), 어린이, 유아, 커플',
    productName01: '패키지이름：',
    productName02: '제품이름：',
    qrCodeName: 'QR코드 이름',
    productName_placeholder: '제품이름을 입력하세요',
    qrCodeName_placeholder: 'QR코드 이름을 입력하십시오',
    productPrice_placeholder: '请输入产品偏移价格',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '자켓 제품은 2차 확인 제품, 주문 확인 방식만 인공 확인 가능',
    errorProductConfirmType2: '자켓 제품은 2차 확인 제품을 포함하지 않고 주문 확인 방식은 자동으로 확인할 수 있다',
    errorProductConfirmType3: '해당 상품은 세트 상품에 포함되어 있기 때문에 예약 확인 방법을 변경할 수 없습니다.',
    orderNum_placeholder: '请输入排序',
    productHighlights01: '패키지특점：',
    productHighlights02: '제품특점：',
    productHighlights_placeholder: '제품특점을 입력하세요',
    productInsideRemark: '내부비고：',
    productInsideRemark_placeholder: '내부비고를 입력하세요',
    scenicSpot: '해당명소：',
    ticketType: '티켓종류：',
    ticketType_placeholder: '티켓종류를 입력하세요',
    productSaleDate: '등록시간대：',
    productSaleDate_placeholder: '등록시간대를 선택하세요',
    chooseDepot_rule: '请选择仓库',
    productName_rule: '제품이름을 입력하세요',
    scenicSpotArr_rule: '최소 1개의 명소를 선택하세요',
    scheduleDuration: '일정시간：',
    scheduleDuration_placeholder: '일정시간을 입력하세요',
    imageExplain: '이미지묘사：',
    uploadBtn: '업로드하기',
    videoExplain: '영상자료：',
    productPackageDetail: '패키지제품상세정보：',
    mealTimeInterval: '식사시간대：',
    mealTime_1: '제한없음',
    mealTime_2: '아침',
    mealTime_3: '점심',
    mealTime_4: '애프터눈티',
    mealTime_5: '저녁',
    mealTime_6: '야식',
    mealNumber: '식사인원：',
    mealNumber_1: '1인식사',
    mealNumber_2: '2인식사',
    mealNumber_3: '3~4인식사',
    mealNumber_4: '5~10인식사',
    mealNumber_5: '10인이상',
    mealDetail01: '이름：',
    mealDetail01_placeholder: '패키지그룹명을 입력하세요',
    mealDetail02: '내용：',
    mealDetail03: 'No.',
    mealDetail04: '이름',
    mealDetail05: '수량',
    mealDetail06: '사진',
    mealDetail07: '실행',
    mealDetail07_del: '삭제',
    mealDetail07_up: '위로 이동',
    mealDetail07_down: '아래로 이동',
    up_msg: '이미 맨 위입니다',
    down_msg: '이미 맨 아래입니다',
    mealDetail07_add: '1행추가',
    md_delGroup: '그룹삭제',
    md_addGroup: '그룹추가',
    md_validMsg: '패키지상세정보 데이터가 완전하지 않습니다',
    md_addMsg: '최대 20항 추가 가능!',
    md_addMsg1: '최대 10그룹 추가 가능!',
    useTime: '사용시간：',
    useTime_1: '제한없음',
    useTime_2: '구제적인 시간대 있음',
    editorProductDetail: '상세문자묘사：',
    viewAddress: '주소：',
    viewAddress_placeholder: '명소주소를 입력하세요',
    businessTime: '영업시간：',
    businessTime_placeholder: '영업시간을 입력하세요',
    productPeople_placeholder: '请输入产品人群要求',
    exclusive: '차량 전용 표식：',
    exclusive_1: '비 전용 차',
    exclusive_2: '남성 전용 차량.',
    exclusive_3: '여성 전용 차량.',
    lang: '서비스언어：',
    lang_1: '중문',
    lang_2: '영문',
    lang_3: '일문',
    lang_4: '韩文',
    productTraffic: '교통방식：',
    productTraffic_placeholder: '교통방식을 입력하세요',
    networkFlow4g: '4G고속데이터：',
    networkFlow4g_placeholder: '4G고속데이터를 입력하세요',
    networkFlow3g: '3G데이터：',
    networkFlow3g_placeholder: '3G데이터를 입력하세요',
    networkCoverage: '네트워크 적용범위：',
    networkCoverage_placeholder: '네트워크 적용범위를 입력하세요',
    wifiAccessories: '부품：',
    wifiAccessories_placeholder: '부품을 입력하세요',
    simSize: '유심크기：',
    simSize_placeholder: '유심크기를 입력하세요',
    pathType: '노선유형：',
    pathType_1: '합승차여행',
    pathType_2: '렌터카여행',
    pathType_3: '픽업샌딩',
    traffic: '교통수단：',
    traffic_1: '자동차',
    traffic_2: '전차',
    traffic_3: '크루즈',
    groupNumber: '그룹인원：',
    groupNumber_placeholder: '그룹인원을 입력하세요',
    shoppingType: '쇼핑정보',
    shoppingType_1: '쇼핑 비포함',
    shoppingType_2: '쇼핑 포함',
    scheduleInfo: '구체적인 일정：',
    productCostInclude: '비용포함：',
    productCostInclude_placeholder: '비용포함 내용을 입력하세요',
    productCostExclusive: '비용 비포함：',
    productCostExclusive_placeholder: '비용 비포함 내용을 입력하세요',
    productUseFlow: '이용과정：',
    productUseFlow_placeholder: '이용과정을 입력하세요',
    productSupplementPath: '使用流程补充',
    userNote: '使用说明：',
    userNote_placeholder: '请输入使用说明',
    importantNote: '重要提示：',
    importantNote_placeholder: '请输入重要提示',
    editorFreeItem: '증정항목：',
    newProductPackageDtoList_rule: '최소 1개의 패키지상세정보를 입력하세요',
    scheduleInfoDtoList_rule: '최소 1개의 일정이 있어야 합니다',
    reserveLimitDay: '예약시간제한：',
    rld01: '사용날짜의',
    rld02: '일전의',
    rld03_placeholder: '시간',
    rld04: '전예약（일본시간）',
    confirmHour: '주문확인방식：',
    confirmHour_1: '자동확인',
    confirmHour_2: '인공확인',
    ch01: '2차확인 처리시간：',
    ch02: '일본영업일 근무시간',
    ch03: '小时（自然时长）',
    maxReserveNummber: '최대 예약수：',
    minReserveNummber: '최소 예약수：',
    mrn_explain: '\'0\'데이터 제한하지 않음을 표시',
    orderValid: '주문유효기간설정：',
    ov01: '지정사용일 당일 유효',
    ov02: '주문한 날부터',
    ov03: '주문한 날부터 지정일까지',
    ov04: '지정사용일부터',
    ov05: '지정사용일부터 지정일까지',
    ov06: '지정날짜',
    ov07: '지정사용일의',
    orderRefund: '주문환불변경：',
    orderRefund_1: '환불변경불가',
    orderRefund_2: '주문유효기간 마감일 전 환불신청가능',
    orderRefund_3: '소비 전 언제든지 환불가능',
    refundDescription: '환불안내：',
    rdi_placeholder: '환불안내를 입력하세요',
    customerData: '예약기입요구：',
    customerData_1: '모든 고객의 자료를 입력해야 합니다',
    customerData_2: '고객 한분의 자료만 입력하면 됩니다',
    mustFillInInf: '고객필수입력정보：',
    mustFillInInf_1: '이름',
    mustFillInInf_2: '전화',
    mustFillInInf_3: '위챗',
    mustFillInInf_4: '여권',
    mustFillInInf_5: '성별',
    mustFillInInf_6: '사용날짜',
    mustFillInInf_7: '수령날짜',
    mustFillInInf_8: '이름(성)',
    mustFillInInf_9: '이름(명)',
    mustFillInInf_10: '연락번호',
    mustFillInInf_11: '메일주소',
    mustFillInInf_12: '성별',
    mustFillInInf_13: '연락번호',
    mustFillInInf_14: '긴급연락번호',
    mustFillInInf_15: '티켓종류',
    mustFillInInf_16: '同行者',
    customItem: '사용자정의 고객 입력사항',
    ci01: '항목이름입력',
    ci01_placeholder: '항목이름',
    ci02: '기입 여부',
    ci02_placeholder: '선택하세요',
    ci02_1: '선택기입',
    ci02_2: '필수기입',
    ci03: '안내(주문 페이지의 입력창 하단에 노출)',
    ci03_placeholder: '안내',
    ci04: '실행',
    ci04_del: '삭제',
    ci05: '사용자정의 항목 추가',
    editorNotice: '예약안내사항：',
    orderLiaison: '주문연락：',
    emergencyLiaison: '긴급연락：',
    validateAuthority: '권한 확인：',
    receiveCounter01: '수령카운터：',
    receiveCounter02: '종이티켓수령카운터：',
    returnCounter: '반환카운터：',
    reserveLimitDay_rule: '예약시간제한을 입력하세요',
    reserveLimitDay_rule1: '1부터 99일 이내',
    reserveLimitDay_rule2: '시간을 입력하세요',
    orderDayNotMore: '주문일부터 일수는 2자리수보다 크면 안됩니다',
    trip01: '제',
    trip02: '일',
    trip03: '일정: ',
    trip04: '새일정추가',
    trip05: '1일추가',
    trip06: '시간대：',
    trip06_placeholder: '시간범위선택',
    trip07: '어디로가세요：',
    trip07_placeholder: '언제 어디로 가세요?',
    trip08: '일정내용：',
    trip08_placeholder: '예시: 몇번째 날에 어디로 가세요? 어떻게 가요? 어떤 특색이 있어요?',
    trip09: '일정이미지：',
    trip09_btn: '업로드 클릭',
    trip10: '일정저장',
    trip_msg1: '일정 미선택',
    trip_msg2: '일, 일정',
    tripRange_rule: '시간대를 입력하세요',
    groupContentTitle_rule: '어디로 가는지 입력하세요',
    groupContent_rule: '일정내용을 입력하세요',
    imageList_rule: '일정이미지를 설정하세요',
    trip_msg3: '먼저 일정을 선택한 뒤 일정을 저장하세요!',
    trip_msg4: '축하합니다. 저장에 성공했습니다',
    price01: '재고와 가격',
    price02: '시간대-',
    price03: '새로 추가된 시간대',
    price04: '삭제',
    price05: '시간대',
    price06: '시간범위 선택',
    price061: '시간대가 중복되면 안 됩니다',
    price07: '구매가격',
    price08: '구매가격을 입력하세요',
    price09: '유통가격',
    price10: '유통가격을 입력하세요',
    price11: '시장가격',
    price12: '시장가격을 입력하세요',
    price13: '재고량',
    price14: '재고량을 입력하세요',
    price15: '건',
    price16: '저장',
    price17: '재설정',
    price18: '날짜범위를 입력해야 합니다',
    price19: '시간대를 입력해야 합니다',
    price20: '날짜범위',
    price21: '円',
    price22: '分销平台采购价',
    price23: '请输入分销平台采购价',
    price24: '零售价',
    price25: '请输入零售价',
    price26: '新增种类',
    price27: '种类名称',
    price28: '请输入种类名称',
    price29: '价格种类-',
    price30: '请选择价格种类',
    price31: '가격 종류의 총 재고를 입력하십시오',
    price32: '총 재고는 사용수보다 많아야 합니다',
    price33: '총 재고는 0 이상이어야 한다',
    price34: '지정된 가격종류를 입력해주세요 : 성인,아동, 신체장애인(성인), 신체장애인(아동)',
    price_msg1: '날짜를 선택하세요',
    price_msg2: '시간대-',
    price_msg3: '미저장',
    price_msg4: '날짜와 시간대를 선택하세요',
    price_msg5: '저장성공',
    price_msg6: '저장실패',
    price_msg7: '삭제성공',
    price_msg8: '삭제실패',
    price_msg9: '최대 50개 데이터 추가 가능',
    price_msg10: '선택한 사항을 입력해야 합니다',
    price_msg11: '정말 이 시간대의 모든 존재하는 데이터를 덮어쓰기하여 저장하시겠습니까?',
    price_msg12: '정말 시간대를 삭제하시겠습니까?.',
    price_msg13: '"의 모든 데이터를 정말 삭제하시겠습니까?',
    price_msg14: '이 가격종류 모든 존재하는 데이터를 덮어쓸 것입니다. 저장하시겠습니까?',
    price_msg15: '이 가격종류의 모든 데이터를 삭제합니다. 삭제하시겠습니까?',
    price_msg16: '이 가격종은 사용 중이므로 삭제할 수 없습니다.',
    price_msg17: '이 제품은 이미 같은 가격 종류가 있어서 저장하는데 실패했습니다',
    refund01: '주문유효기간 마감일 전',
    refund02: '일, 환불수수료: ',
    refund03: '제거',
    refund04: '사용자정의 추가',
    refund05: '환불수수료：',
    counter01: '카운터선택',
    counter02: '카운터',
    counter03: '주소',
    counter04: '전화',
    counter05: '영업시간',
    liaison01: '연락인선택',
    clerk01: '영업 담당자 선택',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: '전화 번호',
    clerk05: '邮箱',
    liaison02: '연락인',
    liaison03: '연락방법',
    liaison04: '접수시간',
    spot01: '해당명소선택',
    spot02: '명소선택',
    spot03: '취소',
    spot04: '확인',
    takeP01: '제품창고에서 제품 선택',
    takeP02: '최소 1개 자제품이 있어야 저장하거나 패키지를 제출할 수 있습니다',
    takeP03: 'No.',
    takeP04: '제목',
    takeP05: '구매가격',
    takeP06: '유통가격',
    takeP07: '시장가격',
    takeP08: '수량',
    takeP09: '실행',
    takeP10: '데이터인용',
    takeP11: '제품창고에서 제품 선택',
    takeP12: '삭제',
    takeP13: '가격 종류',
    takeP14: '차량 전용 표식',
    stockNumber01: '재고량',
    stockNumber02: '사용 갯수',
    stockNumber03: '사용 안 함',
    stockNumber04: '사용 하기',
    priceTypeHistory01: '이력을 확인하다',
    priceTypeHistory02: '재고가 늘다',
    priceTypeHistory03: '재고가 줄어들다',
    upload01: '2MB를 초과하지 않는 jpg/png/jpeg/gif파일만 업로드 가능',
    upload02: '최대 20MB 영상 업로드 가능',
    upload03: '업로드 최대',
    upload04: '장 이미지!',
    upload05: '개 영상!',
    upload06: '이 파일은 유효한 이미지포맷이 아닙니다!',
    upload07: '업로드할 이미지 크기가 2MB를 초과하면 안 됩니다!',
    upload08: '파일명에 쉼표가 있으면 안 됩니다!',
    upload09: '이 파일은 유효한 영상포맷이 아닙니다!',
    upload10: '업로드할 영상 크기가 20MB를 초과하면 안 됩니다!',
    upload11: '업로드실패!',
    upload12: '업로드오류!',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: '하나의 파일',
    upload15: '업로드 파일 크기를 초과할 수 없습니다 5MB！',
    calendar01: '년',
    calendar02: '월',
    calendar03: '당월재고 모두선택',
    calendar04: '건',
    clerkTable01: '모든 영업 담당자가 기본적으로 티켓을 유효성 검사할 수 있습니다',
    week_1: '월',
    week_2: '화',
    week_3: '수',
    week_4: '목',
    week_5: '금',
    week_6: '토',
    week_7: '일',
    explain_1: '구매가격: 플랫폼에 판매하는 가격(플랫폼 매입가), 공급사가 정기적으로 플랫폼에게 청구하는 단가',
    explain_2: '유통가격: 플랫폼이 여행사(유통사)에게 판매하는 가격',
    explain_3: '구매가격과 유통가격의 차액이 플랫폼의 이윤입니다',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: '가격종류 (일본어) 입력설명：',
    explain_9: '성인 비',
    explain_10: '어린이 관람 료.',
    explain_11: '장애인 성인 관람료',
    explain_12: '장애 아동 관람 료',
    explain_13: '(이하의 가격종류만 유효 : 성인, 아동, 신체장애인(성인), 신체장애인(아동))',
    explain_14: '(이용가능날짜를 참고하여, 재고를 설정해 주세요. 이용불가날짜설정은 무효처리됩니다.)',
    explain_15: '이용가능날짜：',
    explain_16: '현재의 가격종류로는 이용가능한 날짜가 존재하지 않습니다.',
    explain_17: '판매 합 니까',
    explain_18: '가격 규칙 설정 설명：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '판매 하 다.',
    notSale: '비재판매',
    productDeleteMessage: '포장제품을 먼저 삭제하거나 포장제품에서 이 제품을 제거하세요!!',
    none: '없다',
    sendMailSet: '발송일을 앞당기다：',
    mailContent: '메시지 내용：',
    noSend: '보내지 않음',
    mailTime: '지정한 날짜 이전',
    mailContent_placeholder: '메일 내용을 입력해 주세요',
    mailsetTips: 'pdf 가 없는 전자 티켓만 지원합니다'
  },
  recharge: {
    depositWithdraw: '충전/인출',
    depositWithdrawHistoryRecord: '충전/인출기록',
    searchStr: '업체명/ID：',
    placeholder1: '업체명/ID를 입력하세요',
    businessType: '업체유형：',
    businessType1: '업체유형',
    placeholder2: '선택하세요',
    search: '검색',
    businessName: '업체이름',
    businessName1: '업체이름：',
    balance: '잔액',
    accountBalance: '계정잔액：',
    operation: '실행',
    deposit: '오프라인충전',
    depositAuto: '온라인충전',
    automatic: '자동 충전',
    withdraw: '인출',
    record: '기록',
    withdrawAvail: '인출가능금액：',
    withdrawAmount: '인출금액：',
    withdrawRemark: '인출비고：',
    cancel: '취소',
    submit: '심사제출',
    depositAmount: '충전금액：',
    depositRemark: '충전비고：',
    all: '전부',
    supplier: '공급사',
    distributor: '유통사',
    submitSuccess: '제출성공',
    subimitFailed: '제출실패',
    message: '인출금액이 인출가능금액보다 크면 안됩니다!',
    goBack: '뒤로',
    dateRange: '시간대선택：',
    placeholder3: '날짜범위선택',
    date: '날짜',
    operator: '실행자',
    type: '유형',
    supplierWithdraw: '업체인출요청',
    platformWithdraw: '운영사인출',
    operationAmount: '충전/인출금액',
    remark: '비고',
    lastWeek: '최근 일주일',
    lastMonth: '최근 한달',
    lastThreeMonth: '최근 3개월',
    message2: '충전금액은 자연수를 입력하세요!',
    message3: '인출금액은 자연수를 입력하세요!',
    message4: '충전금액은 2000,000,000보다 작은 자연수를 입력하세요!'
  },
  order: {
    batchSummary: '배치 상세',
    canBeUseStartDate: '유효한 시작 날짜',
    canBeUseEndDate: '유효종료 날짜',
    createUserName: '저자',
    bulkPurchase: '대량으로 구매하다',
    remarks: '내부 비고',
    orderSource0: '이 시스템',
    orderSource1: '공급업체 C측',
    orderSource2: '对外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: '易去',
    orderSource6: 'KKday',
    orderSource7: '稀客地图',
    orderSource8: '유통업체 C측',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '상품예약일',
    sourceType: '주문원',
    sourceJtr: '공급자',
    sourceJph: 'JPH공급자',
    allDate: '일시',
    productPrice: '단가',
    totalPrice: '총 가격',
    orderInfo: '주문수량,성함',
    newSourceJtr: '运营者订单',
    payTime: '지불시간',
    productUseDate: '상품이용날짜',
    cancelTime: '취소일',
    keyWorld: '키워드입력 ',
    distributor: '유통사',
    secondAgentId: '2급 에이전트ID',
    secondAgentCommission: '2급 에이전트 수익',
    productArea: '소재지',
    supplier: '공급사',
    search: '검색',
    synchronousTime_01: '（데이터 갱신 시간：',
    synchronousTime_02: '）',
    synchronousOrder_01: '업 데이트',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '상품유효기간',
    validateDate: '상품유효기간',
    expirationTime: '기간 이 지나다',
    timeSlot: '날짜를 선택해주세요',
    searchMsg: '예약번호/상품명/고객성함/고객이메일',
    channelOrderId: '타사 예약번호',
    searchDistributor: '총판 이름을 입력하세요',
    searchSupplier: '공급업체 이름을 입력하세요',
    orderExport: '주문도출',
    ticketDepotExport: '창고 목록 다운로드',
    ticketBatchDetailExport: '패치 내역 목록 다운로드',
    productExport: '전체상품보기',
    productExports: '전체상품보기',
    orderId: '예약번호',
    sonOrderId: '子订单号',
    productName: '상품명',
    allBuyQuantity: '구매수량',
    customerName: '고객이름',
    orderExplain: '비고',
    orderExplain1: '주문서 비고 설명 (내부 비고, 판매상 내부만 보이기)',
    orderStatus: '상품상태',
    notPay: '결제대기중',
    beConfirm: '확인대기',
    beingCancel: '취소중',
    haveCanceled: '취소완료',
    haveConfirmed: '예약완료',
    beTicket: '待出票',
    batchHaveDone: '구입 한',
    haveDone: '상품사용완료',
    haveCancel: '취소완료',
    haveRefundRequest: '已申请退款',
    haveRefund: '已退款',
    havePay: '已付款',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: '已出票',
    notPayButCanceled: '미결제취소',
    haveExpired: '만료됨',
    leftHandleTime: '예약처리기간',
    operation: '실행',
    addOrSub: '부분',
    refund: '환불하다',
    beAdd: '추가 주문 추가',
    addOrSubOrRefund: '부분 취소 / 환불',
    source: '원천',
    validateOrder1: '인증 성공',
    validateOrder2: '이 오더 인증할 권한이 없습니다.',
    validateOrder3: '인증 실패',
    validateOrder4: '',
    date_empty: '날짜가 정확하지 않습니다. ',
    myouji_kana_empty: '성(family name)의 포맷이 정확하지 않습니다.',
    namae_kana_empty: '이름(first name)의 포맷이 정확하지 않습니다.',
    bin_key_id_empty: '제품 번호 가 잘못 되 었 습 니 다. 다시 입력 해 주세요.',
    sex_empty: '성별의 포맷이 정확하지 않습니다.',
    tel_empty: '핸드폰 양식 이 잘못 되 었 습 니 다. 10 - 11 자리 숫자 를 입력 하 십시오.',
    email_empty: '잘못된 메 일 박스 입 니 다. 메 일 박스 를 정확하게 입력 하 십시오.',
    total_num_empty: '예약인수의 포맷이 정확하지 않습니다.',
    age_empty: '나이 형식 이 올 바 르 지 않 습 니 다. 숫자 를 입력 하 십시오.',
    emergency_phone_empty: '긴급연락번호의 포맷이 정확하지 않습니다.',
    ctype_empty: '연령구분・장애인구분의 포맷이 정확하지 않습니다.',
    recep_empty: '접수가 완료되었습니다.',
    num_over: '잔량(남은양)이 불충분합니다.',
    num_not_sale: '선택 한 지정 날짜 가 아직 발매 되 지 않 았 습 니 다.',
    r_id_empty: '지정예약ID는 이미 취소가 완료되었습니다.',
    r_id_already_cancel_ok: '예약 이 취소 되 었 습 니 다.',
    r_id_already_payment_ok: '이 예약은 금액지불이 완료되었습니다.',
    thirdMethodErr: '접속연결 오류, 관리인에게 연락해 주세요.',
    systemErr: '시스템 오류, 관리인에게 연락해 주세요.'
  },
  jtrOrder: {
  },
  withdrawal: {
    withdrawalCash: '충전/인출',
    withdrawalCashManager: '충전/인출관리',
    withdrawalOnline: '온라인충전',
    withdrawalOffline: '오프라인충전',
    applyWithdraw: '인출신청',
    beingHandel: '처리대기',
    beingAudit: '심사대기',
    notPass: '심사 미통과',
    selectTimeSlot: '시간대를 선택하세요',
    selectDateSlot: '날짜범위를 선택하세요',
    createTime: '생성시간',
    operationPeople: '실행자',
    type: '유형',
    recharge: '충전',
    withdraw: '인출',
    withdrawAmount: '인출금액',
    rechargeWithdrawAmount: '금액',
    rechargeWithdrawAmount2: '인출금액',
    remark: '비고',
    refundReason: '미통과 이유',
    accountBalance: '계정잔액',
    canWithdrawalBalance: '인출가능금액',
    applyWithdrawalBalance: '인출금액신청',
    applyWithdrawalBalance2: '충전금액신청',
    selectWithdrawalAccount: '인출금액을 선택하여 입력하세요',
    withdrawRemark: '인출비고',
    withdrawRemark2: '충전비고',
    inputWithdrawRemark: '인출비고메세지를 선택하여 입력하세요',
    cancel: '취소',
    sure: '확인',
    submitResigt: '신청제출',
    oneWeek: '최근 일주일',
    oneMonth: '최근 한달',
    threeMonth: '최근 3개월',
    withdrawAmoutIsNotNull: '인출금액을 입력해야 합니다!',
    withdrawAmoutZS: '자연수를 입력하세요!',
    withdrawAmoutMustNumber: '인출금액은 숫자여야 합니다!',
    withdrawAmoutIsNot0: '인출금액은 0보다 커야 합니다!',
    withdrawAmoutIsNotNegative: '인출금액이 음수면 안 됩니다!',
    withdrawAmoutIsNotEnough: '인출가능잔액이 부족합니다!',
    comformWithdrawMsg: '인출 정보를 확인하세요. 계속하시겠습니까?',
    comformWithdrawMsgIfGo: '인출 정보를 확인하세요. 계속하시겠습니까?',
    sureSubmit: '제출하기',
    returnEdit: '돌아가기',
    submitSuccess: '제출되었습니다. 심사를 기다려주세요!',
    companyName: '업체이름',
    companyName2: '업체명',
    companyType: '업체유형',
    distributor: '유통사：',
    supplier: '협력사',
    inputCompanyNameAndId: '업체이름/ID를 입력하세요',
    handle: '처리',
    auditor: '심사',
    auditorPass: '심사통과',
    auditorNotPass: '심사 미통과',
    withdrawHander: '인출처리',
    withDrawAuditor: '인출심사',
    withDrawAuditor2: '충전심사',
    withdrawHander2: '충전처리',
    refuseApply: '신청거절',
    refuseApplyReason: '미통과 이유를 입력하세요',
    handlingSubmittingAudits: '처리 및 심사제출',
    handelSuccess: '처리성공!',
    rechargeFail: '충전실패'
  },
  password: {
    getPassword: '비밀번호 찾기',
    pleaseInputMailAccount: '이메일계정을 입력하세요',
    sendPasswordToMail: '비밀번호 이메일로 발송',
    returnToIndex: '뒤로',
    sendMsg: '업무담당자 이메일을 입력하세요. 시스템이 비밀번호를 초기화하여 해당 이메일로 보낼 것입니다.',
    mattersNeedingAttention: '주의사항',
    tips1: '빈번하게 비밀번호를 찾기 마세요. 하루 최대',
    tips2: '번 찾기기능 사용가능.',
    tipsMsg: '안내정보',
    loginAtonce: '즉시 로그인',
    getUrlAgain: '다시 획득',
    mailCanNotBeEmpty: '이메일을 입력해야 합니다!',
    mailStyleNotRight: '올바른 이메일 형식을 입력하세요!',
    mailHaveSendSuccess: '이메일이 발송되었습니다. 이메일을 확인하세요!',
    theMailInputNotExist: '입력된 이메일이 존재하지 않습니다!',
    theMailNotHaveRight: '활성화되지 않았거나 금지된 이메일주소입니다!',
    aboveOneDayPermit: '하루 최대 허용 시도횟수를 초과했습니다!',
    mailSendFail: '이메일 발송 실패!'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: '이메일을 입력하세요',
    emailError: '잘못된 입력 메 일 박스',
    confirmEmailError: '주문확인 이메일 형식이 올바르지 않습니다',
    pleaseIntoUseDate: '사용시간을 선택하세요',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: '수령시간을 선택하세요',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: '여행객 이름을 입력하세요',
    pleaseSelectStock: '장소 선택',
    customEmailLength: '여행객 이름은 20자 이내여야 합니다',
    pleaseIntoCustomTel: '여행객 휴대폰번호를 입력하세요',
    pleaseIntoNationality: '국적을 입력하십시오',
    pleaseIntoBirthday: '생일을 입력하십시오',
    customTelError: '여행객 휴대폰번호 형식이 올바르지 않습니다',
    customTelError1: '연락번호가 정확하지 않습니다. 10자리 혹은 11자리의 전화번호를 입력해 주세요.',
    customAgeError: '연령의 포맷이 정확하지 않습니다.',
    customSexError2: '여성 전용 차량 때문에 성별을 다시 선택해 주세요.',
    customSexError1: '남자 전용 차량 때문에 성별을 다시 선택해 주세요.',
    pleaseIntoCustomWechat: '여행객 위챗을 입력하세요',
    customWechatError: '여행객 위챗 형식이 올바르지 않습니다',
    pleaseIntoCustomPass: '여행객 여권을 입력하세요',
    customPassError: '여행객 여권 형식이 올바르지 않습니다',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: '남',
    customSexFalmale: '여',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '예약하신 상품의종류와 기입하신 티켓의종류가 다릅니다. 티켓의 종류를 다시 선택해 주세요.',
    pleaseIntoCustomItem: '여행객 사용자정의 내용을 입력하세요',
    quotaPrompt: '0 이상의 정수를 입력하십시오',
    orderOnceBeOne: '주문당 예약수량 최소 1개',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '본 제품 주문당 예약수량 최대',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '본 제품 주문당 예약수량 최소',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '유효기간이 만료됨',
    productsNumError: '재고가 부족하여 주문서를 생성할 수 없습니다',
    productsNumError1: '제품 ',
    productsNumError2: ' - ',
    productsNumError3: ' 재고 부족',
    productsNumError4: ' PDF 전자표 재고 부족',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: '지정날짜를 입력하세요',
    productUseDateBeNull: '오더의 지정일은 비워서는 않된다',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: '현재 시간이 이미 제품의 예정 시간 범위를 초과했으니, 다시 계산해 주세요',
    limitBulking: '유통 업체가 대량 구매 중이므로 구매가 완료되기 전에 새로운 배치 예약을 제출할 수 없습니다. 잠시만 기다려주십시오!',
    designatedDateNull: '날짜를 비우다'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '금액을 입력해주세요',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: '添加失败,产品已存在或未选择产品',
    addError2: '添加失败',
    submitPrice: '价格不能为空!',
    submitMinPrice: '最低价格不能为空!',
    submitMinPrice0: '最低价格必须大于0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: '排序不能为空!',
    submitLength: '价格及排序必须小于等于10位数字',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '정산주기：',
    calculatePeriod1: '정산주기',
    placeholderCalculatePeriod: '정산주기를 선택하세요',
    supplierNameAndId: '공급사/ID：',
    placeholderSupplierNameAndId: '공급사이름/ID를 입력하세요',
    search: '검색',
    supplierName: '공급사이름',
    distributorPayoutAmount: '내야할 금액（JPY）',
    operatorIncomeAmount: '커미션금액（JPY）',
    supplierIncomeAmount: '결제금액（JPY）',
    operation: '실행',
    detail: '상세보기',
    downloadBill: '내역서다운로드',
    lastSixMonth: '최근 6개월',
    return: '뒤로',
    distributorName: '공급사이름：',
    distributorName1: '유통사이름',
    placeholderDistributorName: '유통사이름/ID를 입력하세요',
    finishTime: '완료시간',
    orderId: '주문ID',
    productId: '제품번호',
    productName: '제품이름',
    productType: '제품유형',
    elecTicket: 'E티켓',
    paperTicket: '종이티켓',
    experTicket: '체험',
    daysTicket: '일일여행/1일이상여행',
    wifi: 'Wi-Fi',
    sim: '유심',
    restTicket: '식당',
    traffTicket: '교통',
    packTicket: '혜택패키지상품',
    distributorPayoutAmount1: '받을커미션',
    operatorIncomeAmount1: '커미션금액',
    supplierIncomeAmount1: '결제금액'
  },
  payOrder: {
    payMessageOne: '주문 상세내용을 최종 확인해주세요. 주문은 1시간 내로 결제하지 않으면 취소되므로 빨리 결제해주세요.',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '최종 확인 주문서',
    jtrcancel: '주문 취소',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: '분당 내에 지불하지 않은 것은 취소될 것이다.',
    payMessageTwo: '되도록 빨리 결제해주세요. 제품이 품절되면 구매할 수 없습니다.',
    payMessageThree: '주문',
    payMessageFour: '분 내로 결제하지 않으면 취소됩니다. 빨리 결제해주세요.',
    payMessageFive: '결제 시간초과, 다시 주문해주세요.',
    lineDownTicket: '오프라인 e티켓',
    lineUpTicket: '온라인 e티켓',
    salaryByNow: '선불금결제',
    canBeUseMoney: '사용가능잔액：',
    jtrcanBeUseMoney: '지불 금액',
    remainTimes: '유효 기간',
    payMoney: '결제：',
    applyCancel: '취소 신청',
    payByNow: '즉시결제',
    canBeUseMoneyError: '잔액이 부족하므로 주문을 생성할 수 없습니다',
    orderCanceled: '주문취소됨',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: '주문 결제 시간초과, 자동 취소됨',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: '개수의 오류 취소하기',
    applyerror: '신청이 실패하다'
  },
  supplyOrder: {
    confirmCancel: '취소확인',
    refuseCancel: '취소거절',
    canceleOrder: '주문취소',
    specialCanceleOrder: '特殊取消',
    partnerCancleOrder: '연결 API 취소',
    jtrSpecialCanceleChannel: '패스 항공권 특별 취소',
    writeFff: '点击核销',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: '주문상세정보확인',
    system: '시스템',
    checkedForNew: '새소식 보기',
    orderRefuseMessage: '본 제품은 환불불가 제품이며 환불신청 시 결제한 금액은 반환되지 않으니 이점 유의하시기 바랍니다.',
    canBeTakeBackFree: '환불수수료비율',
    canBeTakeBack: '환불수수료',
    exchangeRate: '汇率差额',
    takeMoney: '실제환불금액',
    orderDetailByDialog: '주문상세확인',
    orderdetail1: '주문①확인',
    orderdetail2: '주문②확인',
    orderdetail3: '주문③확인',
    orderdetail4: '주문④확인',
    orderdetail5: '주문⑤확인',
    orderdetail6: '주문⑥확인',
    orderdetail7: '주문⑦확인',
    orderdetail8: '주문⑧확인',
    orderdetail9: '주문⑨확인',
    fileTypes: '이 파일은 올바르지 않는 pdf형식입니다!',
    reselectFile: '이 파일에 PDF 파일이 포함되지 않았으니 다시 선택하십시오!',
    zipTypes: '이 파일은 올바르지 않는 zip형식입니다!',
    fileSize: '업로드할 pdf는 5MB를 초과하면 안됩니다!',
    fileTypeBy: '파일명에 쉼표가 있으면 안 됩니다!',
    canCancel: '취소',
    downFiles: '파일 다운로드',
    vailTimeMsg: '주문 상태는 유효 기간 수정을 지원하지 않습니다',
    vailTimelaterMsg: '종료 날짜는 현재 날짜보다 이전일 수 없습니다.',
    vailTimeFsjMsg: '후지큐 제품은 유효 기간 변경을 지원하지 않습니다',
    vailTimeEmpty: '유효기간을 선택해주세요'
  },
  productNumberPrice: {
    pleaseIntoTime: '시간을 선택하세요',
    pleaseIntoNumber: '재고를 기입하세요',
    pleaseGetOneToSix: '1~6자리 숫자를 입력하세요',
    pleaseIntoPurchasePrice: '구매가격을 기입하세요',
    pleaseIntoDistorbutionPrice: '유통가격을 기입하세요',
    pleaseIntoMarketPrice: '시장가격을 기입하세요',
    dateCanotBeNull: '날짜범위를 입력해야 합니다',
    confirmDateCanotBeMax: '설정할 시간대는 반드시 제품 등록 시간대 범위 내에 있어야 합니다!',
    distributorCanotBuyMessage: '해당 상품의 판매 권한이 없기 때문에 예약 수 없습니다',
    distributorCanotBuyMessage2: '이 제품은 이미 하선되었으니 이 제품을 구매할 수 없다'
  },
  pwdSet: {
    pleaseIntoOldPwd: '기존 비밀번호를 입력하세요',
    pleaseIntoNewPwd: '새비밀번호를 입력하세요',
    pleaseConfirmPwd: '새비밀번호를 확인하세요',
    pleaseIntoIntoSix: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    mustBeOne: '위에 입력한 것과 일치해야 합니다',
    pleaseIntoCorrectPwd: '올바른 비밀번호를 입력하세요',
    lengthMustOneToSix: '6~16자',
    canotBeIntoNull: '스페이스나 다른 문자를 입력하면 안 됩니다',
    updateNewPwdSuccess: '비밀번호 변경성공, 다시 로그인하세요!',
    oldPwdError: '기존 비밀번호가 틀렸습니다. 다시 입력하세요!',
    oldAndNewNotOne: '두번 입력한 비밀번호가 일치하지 않습니다!',
    pleaseIntoMustItem: '필수입력사항을 입력하세요',
    pleaseEnterPwd: '비밀번호를 입력하세요',
    pleaseEnterPwdAgain: '비밀번호를 한번 더 입력하세요'
  },
  homeMessage: {
    urgnMessage: '이 기능을 실행할 권한이 없습니다!'
  },
  entityTicket: {
    pinTicketNo: '핀 티켓 번호',
    selectDepot: '창고선택',
    pleaseSelect: '선택하세요',
    selectProduct: '제품선택',
    relationProduct: '관련 제품',
    selectPriceType: '选择产品种类',
    saveTicketDepot: '티켓창고저장',
    onlySelectOnePro: '한번 티켓창고 추가 시 1개 제품만 허용됩니다!',
    onlySelectOnePriceType: '添加票仓一次只允许择一个产品种类!',
    depotNameNotBeEmpty: '창고를 입력해야 합니다!',
    productNameNotBeEmpty: '제품을 입력해야 합니다!',
    productPriceTypeNotBeEmpty: '种类不能为空!',
    addSuccess: '추가성공!',
    inDepotSuccess: '입고성공!',
    proHaveExist: '이미 존재하는 제품입니다!',
    selectDepotOut: '출고창고',
    selectDepotIn: '입고창고',
    depotProNum: '재고수량',
    validDate: '유효날짜',
    selectDate: '날짜시간을 선택하세요',
    starEndTicketNo: '시작·종료티켓번호',
    starTicketNo: '시작티켓번호',
    endTicketNo: '종료티켓번호',
    inDepotTicketNo: '입고티켓번호',
    textArea: '단독스캔입구-커셔를 이곳으로 이동시킨 뒤 스캐너로 종이티켓의 바코드를 스캔하세요',
    saveToDepot: '입고저장',
    pleaseInputStarTicketNo: '시작티켓번호를 입력하세요!',
    pleaseInputEndTicketNo: '종료티켓번호를 입력하세요!',
    errorMsg01: '시작티켓번호는 10자리 숫자를 초과하면 안 됩니다!',
    errorMsg02: '종료티켓번호는 10자리 숫자를 초과하면 안 됩니다!',
    errorMsg03: '시작티켓번호는 종료티켓번호보다 크면 안 됩니다!',
    errorMsg04: '입고티켓수량은 2000장을 초과하면 안 됩니다!',
    errorMsg05: '아래 티켓번호는 10자를 초과하면 안 됩니다',
    errorMsg06: '입고창고를 선택하세요',
    errorMsg07: '출고창고와 입고창고가 같으면 안 됩니다!',
    errorMsg08: '만기시간을 선택하세요!',
    errorMsg09: '입고티켓번호를 입력하세요!',
    errorMsg10: '이 입고창고와 이 제품은 티켓창고가 없는 상태입니다. 먼저 티켓창고를 만들고 제품입고를 진행하세요!',
    errorMsg11: '입고창고에 아래 티켓번호가 존재합니다',
    errorMsg12: '출고창고에 아래 티켓번호가 존재하지 않습니다',
    errorMsg13: '이 출고창고와 이 제품은 티켓창고가 없는 상태입니다. 먼저 티켓창고를 만들고 제품출고를 진행하세요!',
    allBathList: '모든 차수 일람',
    batchDetailList: '차수 상세 일람',
    batchNO: '차수번호',
    ticketNO: '티켓번호',
    pleaseInputBatchNo: '차수번호를 입력하세요',
    pleaseInputTicketNo: '티켓번호를 입력하세요',
    inDepotTime: '입고시간',
    inDepotUser: '입고회원',
    importNumber: '삽입수량',
    userNumber: '사용수량',
    invalidateNumber: '폐기수량',
    leftNumber: '남은수량',
    exportNumber: '출고수량',
    thisBatchDetail: '상세',
    clearDepot: '창고정리',
    batchState: '차수상태',
    ticketState: '티켓상태',
    stateOne: '정상',
    stateTwo: '사용됨',
    stateThree: '폐기',
    stateFour: '출고됨',
    stateFive: '정리 한',
    stateSix: '잠긴',
    userOperationTime: '사용(폐기)시간',
    unUseRemark: '비활성화 설명',
    orderId: '주문ID',
    sureClearDepot: '이번 차수 제품에 대하여 정말 창고정리를 하시겠습니까?',
    sureClearDepot2: '이 제품에 대하여 정말 창고정리를 하시겠습니까? ',
    clearDepotSuccess: '창고정리 성공',
    haveCancelClearDepot: '창고정리를 취소했습니다!',
    invalidTicketSuccess: '전부폐기성공!',
    addTicketDepot: '새로 추가된 티켓창고',
    depot: '창고',
    keyWorld: '키워드입력',
    inputProNameAndNo: '제품이름/번호를 입력하세요',
    userTimeQuantum: '사용시간대',
    inputSelectTimeQuantum: '조회시간대를 입력하세요',
    depotId: '창고ID',
    ticketDepotId: '티켓창고ID',
    depotName: '창고이름',
    productId: '제품ID',
    productName: '제품이름',
    fileName: '파일총량',
    depotIn: '입고',
    depotId2: '입고',
    depotId3: '→',
    depotId4: '初始入库',
    depotOut: '출고',
    history: '이력',
    zhang: '장',
    operationUser: '실행자',
    depotType: '창고유형',
    addDepot: '새로 추가된 창고',
    inputDepotName: '창고이름을 입력하세요',
    notAllDepot: '총창고 아님',
    allDepot: '총창고',
    depotRemark: '창고비고',
    remarkMsg: '비고메시지',
    inventoryNumber: '재고량',
    ifIsAllDepot: '총창고 여부',
    yes: '네',
    no: '아니오',
    tips: '주의: 총창고는 하나만 있습니다',
    depotEdit: '창고편집',
    deleteDepot: '정말 이 창고를 삭제하시겠습니까?',
    depotNameIsNotEmpty: '창고이름을 입력해야 합니다!',
    allDepotOnlyOne: '총창고는 하나만 허용됩니다!',
    depotNameOnlyOne: '이미 존재하는 창고이름입니다!',
    userDepotManager: '회원창고관리',
    addDepotToUser: '창고지정',
    addDepotToUserSuccess: '지정성공!',
    notHistory: '이 제품은 이력이 없습니다!',
    pleaseSelectInvalidTicket: '폐기할 티켓번호를 선택하세요!',
    invalidTicketFalid: '전부 폐기실패!',
    someInvalidTicketFalid: '아래 티켓번호 폐기 실패',
    orderQuery: '주문조회：',
    orderQueryPlac: '주문ID를 입력하거나 스캔하세요',
    orderInfo: '주문정보：',
    startStopNumber: '시작종료티켓번호：',
    startNumber: '시작티켓번호',
    stopNumber: '종료티켓번호',
    numberEditPlac: '단독스캔입구-커셔를 이곳으로 이동시킨 뒤 스캐너로 종이티켓의 바코드를 스캔하세요',
    confirmPin: '티켓끊기확인',
    formMsg1: '인증코드, 주문번호를 입력하거나 스캔하세요',
    rule_n1_10: '1~10자리 숫자',
    querySuccess: '조회성공',
    queryFailure: '주문호마가 존재하지 않다',
    queryMsg1: '티켓시작일은 티켓종료일 보다 커서는 않된다，그리고 한번에 많아서 100장만 판매할수있다 ',
    queryMsg2: '끊은티켓 확인：',
    pinMsg1: '티켓끊기성공',
    pinMsg2: '티켓 판매 실패!',
    clearRemark: '창고 비고'
  },
  ticketMessage: {
    pleaseEnterOrderId: '예약 번호를 입력 하십시오.',
    depotName: '창고이름：',
    pleaseIntoDepotName: '창고이름을 입력하세요',
    depotNameNotNull: '창고이름을 입력해야 합니다',
    ticketRemark: '비고메시지：',
    remarkNotNull: '비고메시지를 입력해야 합니다',
    pleaseGetProduct: '제품을 선택하세요',
    fileDepotName: '파일창고이름：',
    batchStatus: '차수상태：',
    batchId: '차수번호',
    pleaseEnterBatchId: '차수번호를 입력하세요',
    enterDate: '시간삽입',
    enterUser: '회원삽입',
    close: '닫기',
    Processing: '처리 중',
    uploadFailure: '업로드 실패',
    ticketDetail: '상세보기',
    newToUse: '우선사용',
    fileStatus: '파일상태：',
    fileName: '파일명：',
    pleaseEnterFileName: 'PDF파일명을 입력하세요',
    fileId: '파일ID',
    fileNames: '파일이름',
    downPdf: 'PDF다운로드',
    ticketMessageBy: '아래 티켓번호 상태가 비정상이므로 폐기에 실패했습니다!',
    noUseMessage: '최소 1개의 파일을 선택하세요!',
    ticketMessageBy2: '이번 실행에 상태가 비정상적인 티켓이 존재합니다. 새로고침 후 다시 시도하세요!',
    operationSuccess: '실행성공!',
    getFile: '파일선택',
    getZipFile: 'ZIP선택',
    getFilesOnlyFive: 'PDF파일 업도드수량을 5로 제한하며 파일당 10MB로 제한합니다',
    getZipOnlyOne: 'ZIP파일 업도드수량을 1로 제한하며 파일당 300MB로 제한합니다',
    usedDate: '유효마감날짜：',
    usedDates: '유효마감날짜',
    ticketMessageBy3: '비었지만 항상 효력이 있습니다.',
    intoNow: '즉시삽입',
    intoSuccess: '삽입성공!',
    insertFileDepot: '새로 추가된 파일창고',
    choose: '选择',
    fileDepotNames: '파일창고이름',
    pleaseIntoFileName: '창고명을 입력하세요',
    canBeUseDate: '사용(폐기)시간대：',
    intoSearchDate: '조회시간대를 선택하여 입력하세요',
    into: '삽입',
    fivePdf: '개PDF!',
    oneZip: '개ZIP!',
    ticketOpen: '열기',
    intoIng: '삽입 중, 잠시만 기다리세요...',
    fileHadExists: '파일이 창고에 이미 존재합니다!',
    uploadSize: '업로드할 이미지 크기가 10MB를 초과하면 안 됩니다!',
    uploadZipSize: '업로드할 이미지 크기가 300MB를 초과하면 안 됩니다!',
    fileNotFors: '파일 업로드 중복 불가!！',
    pleaseGetFile: '파일을 선택하세요',
    fileBatchRemarkNotNull: '비고메시지를 입력하세요'
  },
  remind: {
    remindId: '번호',
    title: '이메일 알림',
    date: '단체 발급일',
    accessory: '부속 서',
    add: '새 알람',
    upload: '첨부 파일 업로드',
    beforeDay: '단체 발송일 n 일 전에 이메일을 발송하여 주의사항을 알리다',
    before: '단체 출발일 전',
    days: '매일 알람 메일을 보냅니다',
    download: '첨부 파일을 다운로드하다',
    reminder: '제시',
    confirm: '확정',
    inputDate: '단체 발송일을 입력해 주세요',
    uploadAccessory: '첨부 파일을 업로드하십시오.',
    inputbeforeDay: '사전 발송일을 입력해주세요',
    inputContent: '메일 내용을 입력해 주세요',
    sendContent: '내용 보내기',
    addRemind: '이메일 알림',
    existRemind: '당일 알림이 이미 존재합니다',
    set: '메일 설정'
  },
  trades: {
    platform: '플랫폼',
    excel: '엑셀도출',
    tradesTime: '거래시간대',
    inputOrderId: '주문번호를 입력하세요',
    tradingTime: '거래날짜',
    operatorUser: '실행자',
    expenditure: '지출',
    income: '수입',
    buyQuantity: '수량',
    customerName: '손님 이름',
    orderExplain: '주문 노트 설명',
    content: '내용'
  },
  pinTicketMagn: {
    pinTicket: '끊은티켓 인증',
    shortcutOut: '빠르게 티켓 끊기',
    all: '전부',
    pinTime: '인증 시간',
    validationType: '끊은 티켓 유형：',
    productName: '제품이름：',
    placeholder1: '제품이름을 입력하세요',
    validateTime: '티켓 끊은 날짜: ',
    placeholder2: '티켓 끊은 날짜를 입력하세요',
    orderId: '주문ID：',
    placeholder3: 'ID를 입력하세요',
    distributor: '유통사：',
    placeholder4: '유통사를 입력하세요',
    validationUser: '티켓소유자: ',
    placeholder5: '티켓소유자를 입력하세요',
    ticketNo: '티켓번호：',
    placeholder6: '티켓번호를 입력하세요',
    colOrderId: '주문ID',
    colOrderContent: '주문내용',
    colValidateTime: '티켓 끊 은시간',
    colValidateType: '끊은 티켓 유형',
    colValidateUser: '티켓소유자',
    colDistributor: '유통사',
    colCustomerOrderNo: '끊은 티켓번호',
    placeholder7: '빠 른 취소 표 번 호 를 입력 하 세 요.',
    colCustomerOperator: '실행자',
    placeholder8: '조작 자 를 입력 하 세 요',
    colticketNo: '티켓번호',
    shortcutOutDepot: '끊은티켓창고',
    shortcutOutProduct: '판매티켓 제품',
    company: '회사',
    orderIdNo: '주문번호',
    distributorNameAndOrderNo: '판매자명 (건의:이니셜) +단일번호',
    pleaseInputOrderCustomer: '고객 주문번호를 입력하세요',
    pleaseInputCustomerOperator: '실행자를 입력하세요',
    shortcutOutSure: '티켓끊기확인',
    ticketCanNotBeCutOut: '아래 티켓번호는 티켓을 끊을 수 없습니다',
    ticketCanNotBeCutOuts: '가격의 종류는 중복된 표를 입력할 수 없다',
    distributeOnlySelectOne: '유통사는 하나만 선택가능',
    ticketNumber100: '들어온 티켓량이 100을 초과하면 안 됩니다!',
    pleaseInputDistribute: '유통사를 입력하세요!',
    pleaseInputOrder: '주문번호를 입력하세요!',
    orderLine100: '주문번호는 100자를 초과하면 안됩니다!',
    inputOperation: '실행자를 입력하세요!',
    operationLine100: '실행자는 100자를 초과하면 안 됩니다',
    shortcutOutSuccess: '티켓끊기성공!'
  },
  errMsg: {
    errMsg100: '주문호마가 존재하지 않다',
    errMsg101: '대응이없는 창고',
    errMsg102: '엄무원만 티켓판매 가능',
    errMsg103: '오더가 유효기한내에 없다',
    errMsg104: '아래 티켓번호는 판매할수 없다',
    errMsg105: '사업자 혹은 특수권함인 협력사는 심사통과의 조작실패를 직접 선택한다',
    errMsg106: '제품ID는 비워서는 않된다',
    errMsg107: '파일 업로드는 비워서는 않된다',
    errMsg108: '서비스내부 이상',
    errMsg109: '오더 이미 완성',
    errMsg110: '오더 미확인',
    errMsg111: '판미한 티켓수와 실제 구매수가 일치하지 않다',
    errMsg112: '대응되는 티켓창이 없다',
    errMsg113: '대응되는 티켓이 없다',
    errMsg114: '请选择产品来源',
    errMsg115: '',
    errMsg116: '이 주문서는 이미 취소되었습니다',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '正在处理中，请勿重复提交'
  },
  pay: {
    type: '충전방식',
    success: '결제완료',
    fail: '결제미완료',
    toUrl: '결제플랫폼으로 가서 결제를 진행해주세요 ',
    toPay: '계속 충전하기',
    error01: '결제에 실패했습니다. 다시 시도해주세요',
    error02: '결제가 완료되었습니다. 중복하여 새로고침하지 마세요',
    loading: '결제 데이터 처리 중...',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: '1MB를 초과하지 않는 jpg/png/jpeg 파일만 업로드 가능',
    upload02: '홈 페이지 사진 사이즈 1920 x 500 화소, 홈 페이지 사진의 요소 패턴은 왼쪽과의 거리가 430 화소 필요해요.',
    pageImg: '홈 페이지 사진：',
    errorByPage01: '홈 페이지 사진에 변화가 없습니다',
    errorByPage02: '홈 페이지 사진은 공백일 수 없습니다！'
  },
  barCode: {
    urlError: 'URL 오류!',
    getInfoError: 'QR코드 불러오기 오류!',
    productTextDescription: '상세문자묘사',
    customerReceiveDate: '수령카날짜：',
    returnDate: '반환카날짜：',
    productUseDate: '지정날짜：',
    buyQuantity: '구매 수량：',
    productUseFlow: '이용과정：',
    productUseName: '성함：',
    validityDate: '성함：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: '이름',
    isDistribution: '판매',
    scale: '커미션 비율',
    YES: '예.',
    NO: '아니.',
    noValue: '없음',
    distributionRange: '제품의 범위를 나누어 권한을 주다.',
    distributionRangeAll: '모두 2차원 부호',
    distributionRangeYes: '지정된 QR코드만 분할 수 있다',
    distributionRangeNo: '지정한 QR코드 이외의 QR코드 제외',
    selectDistributor: '제품 선택',
    tipMessage1: '이름을 입력하십시오',
    tipMessage2: '권한을 선택하십시오',
    tipMessage3: '커미션비율을 입력해 주세요',
    addError1: 'QR코드 소스가 이미 존재하였으니 다시 입력하십시오',
    prompt: '이 막대 QR코드를 삭제하시겠습니까?？',
    searchMore: '제품',
    choseCode: 'QR코드 선택',
    choseCodeError: 'QR코드 선택',
    nickName: '닉네임',
    auditStatus: '심사상태',
    submitAudit: '심사에 동의합니다?',
    submitAudit1: '현금인출에 동의하십니까?',
    cannotSale: '유저를 무효후, QR코드를 통해 구입한 상품은 수수료의 분배는 없습니다.',
    canSale: '유저를 무효후, QR코드를 통해 구입한 상품은 수수료의 분배가 있습니다.',
    remark: '비고',
    agree: '동의',
    handle: '처리',
    notAgree: '기각',
    applyMoney: '인출금액',
    applyMoney1: '인출금액(수수료 별도)',
    chargeMoney: '수수료',
    aduitTime: '심사시간',
    aduitName: '심사인',
    remittanceExport: '송금데이터다운로드',
    realName: '계좌명의',
    bankNo: '계자번호',
    bankName: '은행명',
    branchName: '지점명',
    accountType: '계좌종류',
    tocDistributor: '소속 에이전트',
    distributorName: '2급 에이전트 닉네임',
    twoDistributor: '2급 에이전트 닉네임',
    oneDistributor: '에이전트',
    drawaltip1: '인출금액이 잔고의 금액을 초과하고 있습니다.',
    drawaltip2: '인출금액이 수수료금액보다 낮습니다.',
    drawaltip3: '인출금액을 입력해 주세요.',
    drawaltip4: '현금인출신청 처리중입니다. 처리완료까지 잠시만 기다려주세요',
    saleName: '유저',
    saleMoney: '2급 에이전트 수익',
    distributorMoney: '에이전트 수익',
    isHasMoney: '입금상태',
    isPay: '입금완료',
    notPay: '미입금',
    handleStatus: '처리상태',
    handleStatus1: '처리대기',
    handleStatus2: '처리완료',
    handleStatus3: '기각완료',
    handleBy: '처리인',
    handleTime: '처리시간',
    setCharge: '수수료설치',
    chargeConfirm: '인출 수수료의 변경을 확정하시겠습니까?',
    accountStatus: '계정상태',
    canUse: '유효로 합니다',
    cannotUse: '무효로 합니다',
    cannotUse1: '연계해제완료',
    incomeAmount: '수익금액',
    tocIncomeAmount: 'C단 계정 잔고',
    withdrawalError1: '계좌명의를 입력해 주세요',
    withdrawalError2: '계좌번호를 입력해 주세요',
    withdrawalError3: '은행명을 입력해 주세요',
    withdrawalError4: '지점명을 입력해주세요',
    withdrawalError5: '예금종목를 입력해 주세요',
    handleError1: '본 유저의 잔고부족으로, 인출처리를 할수 없습니다',
    handleError2: '인출처리는 운영자만 조작가능！',
    handleError3: '잔고부족으로, 인출처리를 할수 없습니다',
    withdrawalTips: '일본엔 1만엔이상(1만엔포함)의 경우에는 수수료가 없습니다.;일본엔 1만엔이하, 고정수수료가 발생합니다',
    withdrawalTips1: '일본엔 1만엔이상(1만엔포함)의 경우에는 수수료가 없습니다.',
    withdrawalTips2: '일본엔 1만엔이하, 고정수수료가 발생합니다',
    applyCash: '현금인출신청',
    applyBy: '신청자 유형',
    applyUser: '신청자',
    twoApplyName: '2급 에이전트',
    cannotCharge: '설정 금액은 양의 정수 여야합니다',
    name: '명칭.',
    Unbundling: '연계해제',
    UnbundTips: '연계해제후, 이 사용자에는 판매커미션이 발생하지 않습니다.',
    cannotUnbund: '송금미완료인 커미션이 있습니다. 연계해제할수 없습니다.',
    twoApplyNameID: '2급 에이전트ID',
    inputScale: '분배하는 커미션율을 입력해주세요.',
    keyTips: '2급 에이전트ID/2급 에이전트 닉네임',
    saleLog: '직판 기록',
    withdrawalTips4: '잔액 부족, 일시적으로 현금 인출 불가'
  },
  payWay: {
    balance: '계정잔액',
    weChat: '위챗',
    alipay: '알리 페이',
    creditCard: '카드',
    unionPay: '은 련',
    weChatWay: '위 채팅 페이',
    payedId: '지불 번호',
    alipayWay: '알리 페이',
    isPay: '예약 결제 중',
    codeTips: 'QR 코드 유효 기간 만료 다시 검색하십시오',
    codeTips1: 'QR 코드 재 취득',
    codeTips2: '위 채팅',
    codeTips3: 'QR 코드를 스캔',
    codeTips4: '알리 페이로',
    codeTips5: 'QR 코드를 스캔',
    refundTips: '예약은 취소되었습니다 지불 전액은 결제 업체에 환불합니다. 숙박 사수 부탁합니다.',
    refundTips1: '예약은 이미 지불 된 결제 금액은 결제 업체에 환불합니다. 숙박 사수 부탁합니다.',
    refundTips2: '예약 지불 방법으로 지불 삼십일 초과 한 경우 환불되지 않습니다, 양해 바랍니다.',
    refundTips3: '예약 결제가 실패했습니다 이미 지불 한 경우, 지불 원래 전액을 환불합니다. 숙박 사수 부탁합니다.',
    errorTips: '결제 정 보 를 가 져 오 는 데 실 패 했 습 니 다. 다시 가 져 오 세 요.',
    payTitle: '접속처 대량으로 구입하다'
  }
}




// WEBPACK FOOTER //
// ./src/local/ko.js